import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import Zoom from "react-medium-image-zoom";
import DeleteIcon from "@mui/icons-material/Delete";
// import SearchIcon from "@mui/icons-material/Search";
// import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
// import reLocatIcon from "../../../assets/Images/Reallocation.png";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import CallIcon from "@mui/icons-material/Call";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
//api integration
import { Formik, Form } from "formik";
import AddIcon from "@mui/icons-material/Add";

import * as Yup from "yup";
import { useEffect } from "react";
import {
  makeGetRequest,
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
// import FamilyMembersTable from "./FamilyMembersTable";
// import VehicelDetailsTable from "./VehicelDetailsTable";

import CreateIcon from "@mui/icons-material/Create";
// import { styled } from "@mui/material/styles";

// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import { AltRoute, EdgesensorLow, Edit, LoginOutlined } from "@mui/icons-material";
// Import For According
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// End

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DoneIcon from "@mui/icons-material/Done";

// For Modal
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Input from "@mui/material/Input";
import reecordNotFound from "../../../assets/Images/noData2.gif";
import AddHomeIcon from "@mui/icons-material/AddHome";
import { upload } from "@testing-library/user-event/dist/upload";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   // hide last border
//   "&:last-child td, &:last-child th": {
//     border: 0,
//   },
// }));

//Validations For Resident Details
const Validation_Schema = Yup.object().shape({
  firstname: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([a-z.A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  lastname: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  contact: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits long")
    .max(10, "phone no must be 10 digits long")
    .required("Required"),
  email: Yup.string()
    .matches(
      /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
      "Invalid Email Id"
    )
    .email("Invalid email")
    .required("Required"),
  age: Yup.string()
    .required("Required")
    .matches(/^\d+$/, "The field should have digits only"),
  // .matches(/^\d{10,14}$/,"Age must be between 1 to 99"),
  family_mem_cnt: Yup.number()
    .min(0, "Invalid Count ")
    .max(30, "Invalid Count")
    .required("Required"),
  flat_cnt: Yup.string()
    .matches(/^\d+$/, "The field should have digits only")
    .min(1, "Invalid Count ")
    .max(1, "Invalid Count ")
    .required("Required"),
});

//Validations For Resident Family
const Validation_Schema_family = Yup.object().shape({
  fam_firstname: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  fam_lastname: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  fam_contact: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits long")
    .max(10, "phone no must be 10 digits long")
    .required("Required"),
  fam_email: Yup.string().email("Invalid email").required("Required"),
  fam_age: Yup.number()
    .required("Required")
    .required("Required")
    .min(1, "Age Must Be At Least 1 Year")
    .max(99, "Please Enter Valid Age"),
  relation: Yup.string().required("Required"),
  // fam_apartment_no: Yup.boolean().required("Required"),
});

const Validation_Schema_Tenentfamily = Yup.object().shape({
  fName_TenentFam: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  lName_TenentFam: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  contact_TenentFam: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits long")
    .max(10, "phone no must be 10 digits long")
    .required("Required"),
  email_TenentFam: Yup.string().email("Invalid email").required("Required"),
  age_TenentFam: Yup.number()
    .required("Required")
    .min(1, "Age Must Be At Least 1 Year")
    .max(99, "Please Enter Valid Age"),
  relation_TenentFam: Yup.string().required("Required"),
});

const Validation_Schema_Tenents = Yup.object().shape({
  firstname_tents: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  lastname_tents: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  contact_tents: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits long")
    .max(10, "phone no must be 10 digits long")
    .required("Required"),
  email_tents: Yup.string().email("Invalid email").required("Required"),
  tenent_age: Yup.number()
    .required("Required")
    .min(1, "Age Must Be At Least 1 Year")
    .max(99, "Please Enter Valid Age"),
  family_member: Yup.number()
    .min(0, "Invalid Count ")
    .max(30, "Invalid Count")
    .required("Required"),
  // vehicle_number: Yup.string()
  // .required("Required"),
  tenentBuilding: Yup.string(),
  wing_id: Yup.string(),
  // apartment_id: Yup.string(),
  // vehicle_owner_name:Yup.string()
  // .required("Required"),
  // vehicle_reg_number:Yup.string()
  // .required("Required"),
});

const Validation_Schema_vehicle = Yup.object().shape({
  // vehicleType:Yup.string()
  // .required("Required"),
  ownername: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  vehicleno: Yup.string()
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-HJ-NP-Z]{1,2}[0-9]{4}$/,
      "Vehicle No like eg.MH17BQ4125 "
    )
    .required("Required"),
});

const Validation_Schema_TenentVehicle = Yup.object().shape({
  tenentV_OwnerName: Yup.string()
    .required("Required")
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  // tenentV_RegNo: Yup.string()
  // .matches( /^[A-Z]{2}[0-9]{2}[A-HJ-NP-Z]{1,2}[0-9]{4}$/,'Vehicle No like eg.MH17BQ4125 ')
  //   .required("Required"),
  tenentVehicleNo: Yup.string()
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-HJ-NP-Z]{1,2}[0-9]{4}$/,
      "Vehicle No like eg.MH17BQ4125 "
    )
    .required("Required"),
});

function TabPanel(props) {
  // const navigate = useNavigate();

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ResidentDetailsTab(props) {
  // For According
  const [expanded, setExpanded] = React.useState(false);

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );
  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  const handleChange2 = (panel) => (event2, isExpanded) => {
    // alert("In Handle Change2")
    // if(localStorage.getItem("tenentId"))
    if (panel === "panel2") {
      GetFamilyMemAllocatedApartments();
      setfam_email(email);
      setfam_contact(contact);
    } else if (panel === "panel03") {
      setEmail_TenentFam(email_tents);
      setContact_TenentFam(contact_tents);
    }
    setExpanded(isExpanded ? panel : false);

    // else
    // swal("First select tenent...", '', "warning");
  };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");
  const [docErrorMsg, setDocErrorMsg] = React.useState("");
  const [vehDocErrorMsg, setVehDocErrorMsg] = React.useState("");
  const [tenentDocErrorMsg, setTenentDocErrorMsg] = React.useState("");
  const [tenentVehDocErrorMsg, setTenentVehDocErrorMsg] = React.useState("");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const [ownername, setownername] = React.useState("");
  const [registrationno, setregistrationno] = React.useState("");
  const [vehicleno, setvehicleno] = React.useState("");

  const [tenentV_OwnerName, setTenentVOwnerName] = React.useState("");
  const [tenentV_RegNo, setTenentVRegNo] = React.useState("");
  const [tenentVehicleNo, setTenentVehicleNo] = React.useState("");

  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [email, setemail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [age, setage] = React.useState("");
  const [family_mem_cnt, setfamily_mem_cnt] = React.useState(0);
  const [flat_cnt, setflat_cnt] = React.useState(0);
  const [parkingsloat, setparkingsloat] = React.useState("");
  const [isEmergencyContact, setIsEmergencyContact] = React.useState(false);

  const [fam_firstname, setfam_firstname] = React.useState("");
  const [fam_lastname, setfam_lastname] = React.useState("");
  const [fam_contact, setfam_contact] = React.useState("");
  const [fam_email, setfam_email] = React.useState("");
  const [fam_age, setfam_age] = React.useState("");
  const [relation, setrelation] = React.useState("");
  const [fam_apartment_no, setFamMemAptmtNo] = React.useState("");
  const [fam_Aptmt_Id, setFamAPtmtId] = React.useState("");
  const [famlisting, setfamlisting] = React.useState([]);
  const [apartmentlist, setapartmentlist] = React.useState([]);

  const [, setlengthfam] = React.useState("");
  // const [firstnmedit, setfirstnmedit] = React.useState("");
  // const [lastnmedit, setlastnmedit] = React.useState("");
  // const [contactedit, setcontactedit] = React.useState("");
  // const [emailidedit, setemailidedit] = React.useState("");
  // const [ageedit, setageedit] = React.useState("");
  // const [familycntedit, setfamilycntedit] = React.useState("");
  // const [flatcntedit, setflatcntedit] = React.useState("");
  const [aprtlistedit, setaprtlistedit] = React.useState([]);
  const [tenentslist, setTenentslist] = React.useState([]);
  const [buildingval, setbuildingval] = React.useState("");
  const [isCurrentStay, setIsCurrentStay] = React.useState(true);

  const [apartBuilErrMsg, setApartBuilErrMsg] = React.useState("");
  const [apartWingErrMsg, setApartWingErrMsg] = React.useState("");
  const [apartNameErrMsg, setApartNameErrMsg] = React.useState("");
  const [apartParkingSlotErrMsg, setApartParkingSlotErrMsg] =
    React.useState("");
  const [apartResTypeErrMsg, setApartResTypeErrMsg] = React.useState("");

  const [firstname_tents, setfirstname_tents] = React.useState("");
  const [lastname_tents, setlastname_tents] = React.useState("");
  const [contact_tents, setcontact_tents] = React.useState("");
  const [email_tents, setemail_tents] = React.useState("");
  const [tenent_age, setTenent_age] = React.useState();
  const [tenentBuilding, setTenentBuilding] = React.useState("");
  const [tenentWing, setTenentWing] = React.useState("");
  const [tenentApartment, setTenentApartment] = React.useState("");

  const [fName_TenentFam, setFName_TenentFam] = React.useState("");
  const [lName_TenentFam, setlName_TenentFam] = React.useState("");
  const [contact_TenentFam, setContact_TenentFam] = React.useState("");
  const [relation_TenentFam, setRelation_TenentFam] = React.useState("");
  const [email_TenentFam, setEmail_TenentFam] = React.useState("");
  const [age_TenentFam, setAge_TenentFam] = React.useState("");
  const [tenentFamMemList, setTenentFamMemList] = React.useState([]);
  const [, setTenentFamMemlength] = React.useState("");

  const [tenentVehicleList, setTenentVehicleList] = React.useState([]);

  const [family_member, setfamily_member] = React.useState("");
  // const [vehicle_owner_name, setvehicle_owner_name] = React.useState("");
  // const [vehicle_reg_number, setvehicle_reg_number] = React.useState("");
  // const [vehicle_number, setvehicle_number] = React.useState("");
  const [wingval, setwingval] = React.useState("");
  const [apartmentval, setapartmentval] = React.useState("");
  const [residentty, setresidentty] = React.useState("");

  const [vehilisting, setvehilisting] = React.useState([]);
  const [, setlengthvehi] = React.useState("");
  const [showAptmtAccordian, setShowAptmtAccordian] = React.useState(false);
  const [showFamVehAccordian, setShowFamVehAccordian] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  const [cnt_mng, setcnt_mng] = React.useState(0);
  // let cnt_apr = 1;
  const [aptar, setaptar] = React.useState([]);
  const [buildingList, setBuildingList] = React.useState([]);
  const [wingList, setWingList] = React.useState([]);

  // async function SendNotification(id, fname, lname, profile_pic, guest_type) {
  //   var fcm_token = localStorage.getItem("fcm_token");
  //   var jsonObj = {
  //     id: id,
  //     fname: fname,
  //     lname: lname,
  //     picture: profile_pic,
  //     guest_type: guest_type,
  //   };

  //   let bodyFormData = {
  //     title: "Need to Extend Stay!!",
  //     message: "Need to Extend Stay!!",
  //     firebaseToken: fcm_token,
  //     extraData: jsonObj
  //   };

  //   await makePostRequest("guards/sendNotification", bodyFormData)
  //     .then((response) => {
  //       //   setState({ openTost: true });
  //       // enqueueSnackbar(notification.body);
  //       // setShow(true);
  //     })
  //     .catch((err) => {
  //       swal(
  //         "There was an error in sending Notification!!",
  //         "more error details",
  //         "warning"
  //       );
  //     });
  // }

  // Add Or Edit Apartment
  // const [lstApttoAdd, setLstAptToAdd] = React.useState([]);

  const [lstUniqAptNames, setLstUniqAptNames] = React.useState([]);
  const [propsResidentId, setPropsResidentId] = React.useState(props.name);
  const [usertypechk, setusertypechk] = React.useState('');

  async function viewresident() {
    let bodyFormData = "";
    // alert(propsResidentId)
    if (propsResidentId) {
      setShowLoader(true);
      await makeGetRequest(
        "resident/getalldetails/" + propsResidentId,
        bodyFormData
      )
        .then((response) => {
          if (response.status === 201) {
            
            console.log("first",response.data.data.user_type)
            setusertypechk(response.data.data.user_type)
            // if (response.data.data == null) alert("Null Data");
            localStorage.setItem("residentid", response.data.data.resident_id);
            localStorage.setItem(
              "residentName ",
              response.data.data.user_obj.first_name +
                " " +
                response.data.data.user_obj.last_name
            );
            document.getElementById("email").setAttribute("readonly", true);
            setfirstname(response.data.data.user_obj.first_name);
            setlastname(response.data.data.user_obj.last_name);
            setcontact(response.data.data.user_obj.contact_no);
            setemail(response.data.data.user_obj.email_id);
            setPassword(response.data.data.password);
            setage(response.data.data.user_obj.age);
            setProfilePic(response.data.data.user_obj.profile_pic);
            setfamily_mem_cnt(response.data.data.family_count);
            setflat_cnt(response.data.data.apartment_count);
            setcnt_mng(response.data.apartmentList.length);
            setaprtlistedit(response.data.data.apartment_id_list || []);
            setresidentty(response.data.data.resident_type);
            setfamlisting(response.data.familyMemberList);
            setvehilisting(response.data.vehicleList);
            setTenentslist(response.data.tenentList);
            setTempAptCnt(response.data.tenentList.length);
            console.log("Wing List ", response.data.data.wing_ids_list);

            setWingList(response.data.data.wing_ids_list  || []);
            setBuildingList(response.data.data.building_ids_list  || []);
            setLstUniqAptNames(response.data.data.uniq_apt_name || []);

            setapartmentlist(response.data.apartmentList  || []);
            setFamilyMemAptList([]);        
            if (response.data.apartmentList) {
              for (var i = 0; i < response.data.apartmentList.length; i++) {
                if (
                  response.data.apartmentList[i].occupancy_type ==
                  "Owner Occupied"
                ) {
                  familyMemAptList.push(response.data.apartmentList[i]);
                }
              }
              setFamilyMemAptList(familyMemAptList);
            }
            setIsEmergencyContact(response.data.data.emergency_contact);
            if (response.data.data.document_list.length > 0) {
              setDocumentsList(response.data.data.document_list);
            } else setDocumentsList([]);
            GetTenentOccupiedAptmtLength();
            if (localStorage.getItem("buildingCnt") > 0)
              GetTenentOccupiedBuildingList(propsResidentId);
            setShowAptmtAccordian(true);
            if (response.data.data.apartment_id_list?.length > 0)
              setShowFamVehAccordian(true);
          } else {
            swal("No Data Found!", "", "warning");
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          console.log(err);
          swal(" " + err.response.data.message, "", "warning", {
            timer: 2000,
            buttons: false,
          });
        });
    }
  }

  const [ownerOccupiedDate, setOwnerOccDate] = React.useState("");
  const [familyMemAptList, setFamilyMemAptList] = React.useState([]);

  // change for edit apartment issue solve change by gautami 24-09-2024
  async function addappartment() {
    let inputdata = "";
    // alert(residentty)
    setApartResTypeErrMsg("");
    setApartNameErrMsg("");
    setApartBuilErrMsg("");
    setApartParkingSlotErrMsg("");
    setApartWingErrMsg("");
    let currentStay = true;

    if (
      buildingval == "" ||
      buildingval == null ||
      wingval == "" ||
      wingval == null ||
      apartmentval == "" ||
      apartmentval == null ||
      parkingsloat == "" ||
      parkingsloat == "" ||
      residentty == "" ||
      residentty == null
    ) {
      // swal("Warning", "Please Fill All Apartment Details", "warning", {
      //   timer: 3000,
      //   buttons: false,
      // });

      if (!buildingval) setApartBuilErrMsg("Required");
      if (!wingval) setApartWingErrMsg("Required");
      if (!apartmentval) setApartNameErrMsg("Required");
      if (!parkingsloat) setApartParkingSlotErrMsg("Required");
      if (!residentty) setApartResTypeErrMsg("Required");
    } else {
      let aptName;

      // if (selectedBuild && selectedWing && apartmentval)
      //   aptName = selectedBuild + "/" + selectedWing + "/" + apartmentval;
      //   // aptName = `${selectedBuild}/${selectedWing}/${apartmentval}`;
      // console.log("aprt nm:", aptName);
      // console.log("selectedBuild:", selectedBuild);
      // console.log("selectedWing:", selectedWing);
      // console.log("apartmentval:", apartmentval);

      if (selectedBuild && selectedWing && apartmentval) {
        console.log("in if:", aptName);
        aptName = selectedBuild + "/" + selectedWing + "/" + apartmentval;
      } else {
        // aptName = response.data.data.uniq_apt_name || "";
        console.log("in els:")

        const buildingSelect = document.getElementById("buildingId");
        const wingSelect = document.getElementById("wingId");
        const apartmentSelect = document.getElementById("apartmentId");
      
        const buildingName = buildingSelect?.options[buildingSelect.selectedIndex]?.text || "";
        const wingName = wingSelect?.options[wingSelect.selectedIndex]?.text || "";
        const apartmentNo = apartmentSelect?.options[apartmentSelect.selectedIndex]?.text || "";
      
        aptName = `${buildingName}/${wingName}/${apartmentNo}`;
        
        
      }



      if (edapartflg == true) {
        var isResident;

        // alert(localStorage.getItem("residentid"));

        if (residentty == "Owner Occupied" || residentty == "Vacant") {
          isResident = true;
        } else isResident = false;

        if (residentty != "Owner Occupied") {
          setIsCurrentStay(false);
          currentStay = false;
        }
        
        inputdata = {
          apartment_id: aparteditid,
          building_id: parseInt(buildingval),
          wing_id: parseInt(wingval),
          apartment_no: apartmentval,
          assigned_parking: parkingsloat,
          is_resident: isResident,
          uniq_apt_name: aptName,
          occupancy_type: residentty,
          is_current_stay: isCurrentStay,
          resident_id: localStorage.getItem("residentid"),
        };
        console.log("inputdata", inputdata);
        setShowLoader(true);
        await makePostRequest("apartment/update", inputdata)
          .then((response) => {
            if (response.data.status === "1") {
              setaptar([...aptar, response.data.data.apartment_id]);
              setBuildingList([
                ...buildingList,
                response.data.data.building_id,
              ]);
              setWingList([...wingList, response.data.data.wing_id]);

              swal("Success", "Apartment updated successfully", "success", {
                timer: 3000,
                buttons: false,
              });

              setaparteditid("");
              setapartmentval("");
              setwingval("");
              setbuildingval("");
              setparkingsloat("");
              setedapartflg(false);
              setUniqAptName("");
              setIsCurrentStay(true);
              viewresident();
              // setExpanded(false);
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal(" " + err.response.data.message, "", "warning", {
              timer: 2000,
              buttons: false,
            });
          });
      } else {
        // insert apart
        // setUpload(!Upload);
        if (flat_cnt == 0) {
          swal("please add flat count");
        } else if (flat_cnt > cnt_mng) {
          setcnt_mng(cnt_mng + 1);
          var isResident;
          // alert(residentty);
          if (residentty == "Owner Occupied" || residentty == "Vacant")
            isResident = true;
          else isResident = false;

          if (residentty != "Owner Occupied") {
            setIsCurrentStay(false);
            currentStay = false;
          }

          inputdata = {
            building_id: parseInt(buildingval),
            wing_id: parseInt(wingval),
            apartment_no: apartmentval,
            assigned_parking: parkingsloat,
            is_resident: isResident,
            uniq_apt_name: aptName,
            resident_id: localStorage.getItem("residentid"),
            occupancy_type: residentty,
            is_current_stay: currentStay,
          };
          console.log("test>>>>>",inputdata)
          setShowLoader(true);
          console.log('Current aprtlistedit:', aprtlistedit);
console.log('Current aptar:', aptar);
          await makePostRequest("apartment/insert", inputdata)
            .then((response) => {
              console.log("apartment added ", response);
              if (response.data.status === "1") {
                if (propsResidentId > 0) {

                  // chk
                  aprtlistedit.push(response.data.data.apartment_id);
                  setaprtlistedit(aprtlistedit);
                } else {
                  aptar.push(response.data.data.apartment_id);
                  setaptar(aptar);
                }

                apartmentlist.push(response.data.data);
                setapartmentlist(apartmentlist);

                if (!wingList.includes(response.data.data.wing_id)) {
                  wingList.push(response.data.data.wing_id);
                  setWingList(wingList);
                }

                if (!buildingList.includes(response.data.data.building_id)) {
                  buildingList.push(parseInt(response.data.data.building_id));
                  setBuildingList(buildingList);
                }

                if (!lstUniqAptNames.includes(aptName)) {
                  lstUniqAptNames.push(aptName);
                  setLstUniqAptNames(lstUniqAptNames);
                }
              }
            })
            .catch((err) => {
              setShowLoader(false);
              console.log("err in catchblk",err)
              // if (err.response && err.response.data && err.response.data.message) 
              swal(" " + err.response.data.message, "", "warning", {
                timer: 2000,
                buttons: false,
              });
            });

          // Code to update aprtment,building, wing details in Resident Details
          // Start======
          let residentData = {
            resident_id: localStorage.getItem("residentid"),
          };

          if (propsResidentId > 0) {
            residentData.apartment_id_list = aprtlistedit;
          } else {
            residentData.apartment_id_list = aptar;
          }
          residentData.uniq_apt_name = lstUniqAptNames;
          residentData.wing_ids_list = wingList;
          residentData.building_ids_list = buildingList;
          residentData.user_type = "Resident User";
          // if (residentty == "Owner Occupied" || residentty == "Vacant")
          //       residentData.occupied_date=new Date();
          // if (isResident) residentData.user_type = "Resident User";
          if(usertypechk=='Admin Owner') {
            residentData.user_type = "Admin Owner";
          }

          await makePostRequest("resident/update", residentData)
            .then((response) => {
              // checked codition if responce is empty
              console.log("Apart Update Resident Update >>>>", response);
              if (response.data.data !== undefined) {
              }
              setShowLoader(false);
              setShowFamVehAccordian(true);

              setapartmentval("");
              setwingval("");
              setbuildingval("");
              setparkingsloat("");
              setresidentty("");
              setUniqAptName("");
              setIsCurrentStay(true);
            })
            .catch((err) => {
              swal("There was an error!", err, "warning");
            });

          //==End ================

          if (flat_cnt > apartmentlist.length) {
            const optionSelected = await swal({
              title: "Apartment allocated successfully",
              text: "Do you want to allocate one more Apartment?",
              icon: "success",
              dangerMode: true,
              buttons: ["No", "Yes, add one more"],
            });
            console.log(optionSelected);
            if (optionSelected) {
              if (flat_cnt > cnt_mng) {
                setExpanded("panel1");
              } else {
                swal(
                  " Your Maximum Apartment Already Allocated",
                  "Not Able To Allocate More Apartment",
                  "warning"
                );
                setExpanded("panel2");
                GetFamilyMemAllocatedApartments();
                swal("Success", "Please Add Family Members", "success", {
                  timer: 3000,
                  buttons: false,
                });
              }
            } else {
              setExpanded("panel2");
              GetFamilyMemAllocatedApartments();
              swal("Success", "Please Add Family Members", "success", {
                timer: 3000,
                buttons: false,
              });
            }
          } else {
            swal(
              " Your Maximum Apartment Already Allocated",
              "Not Able To Allocate More Apartment",
              ""
            );
            GetFamilyMemAllocatedApartments();
            setExpanded("panel2");
            if (edapartflg == false) {
              swal("Success", "Please Add Family Members", "success", {
                timer: 3000,
                buttons: false,
              });
            }
          }
        } else {
          swal(
            " Your Maximum Apartment Already Added",
            "Not Able To Add More Apartment",
            "warning"
          );
          // document.getElementById("residentSubBtn").disabled = false;
          setapartmentval("");
          setwingval("");
          setbuildingval("");
          setparkingsloat("");
          setresidentty("");
          setIsCurrentStay(true);
        }
      }
      GetTenentOccupiedBuildingList(localStorage.getItem("residentid"));
      GetTenentOccupiedAptmtLength();
    }
    // setFamilyMemAptList([]);
    // for (var i = 0; i < apartmentlist.length; i++) {
    //   if (apartmentlist[i].occupancy_type == 'Owner Occupied') {
    //     familyMemAptList.push(apartmentlist[i])
    //   }
    // }
    // setFamilyMemAptList(familyMemAptList);
  }

  async function handleCancelAptmt() {
    // alert("handleCancelAptmt called")

    setedapartflg(false);
    setaparteditid("");
    setbuildingval("");
    setwingval("");
    setapartmentval("");
    setparkingsloat("");
    setresidentty("");
    setApartResTypeErrMsg("");
    setApartNameErrMsg("");
    setApartBuilErrMsg("");
    setApartParkingSlotErrMsg("");
    setApartWingErrMsg("");
    setIsCurrentStay(true);
    setExpanded("panel1");
  }

  async function addBunglow() {
    let inputdata = "";
    setApartNameErrMsg("");
    setApartParkingSlotErrMsg("");
    setApartResTypeErrMsg("");
    let currentStay = true;

    console.log("Resident Type " + residentty);
    if (
      apartmentval == "" ||
      parkingsloat == "" ||
      residentty == "" ||
      residentty == undefined
    ) {
      // alert("Index of  " + allapartment.indexOf(apartmentval));
      // swal("Please fill Bungalow Details", "", "warning");

      if (!apartmentval) setApartNameErrMsg("Required");
      if (!parkingsloat) setApartParkingSlotErrMsg("Required");
      if (!residentty) setApartResTypeErrMsg("Required");
      // if((/^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi).test(apartmentval))
      //   setApartNameErrMsg("Invalid Bunglow Name")
    } else {
      let isAddOrEdit = true;
      let inputdata = {
        apartmentName: apartmentval,
      };

      await makePostRequest("apartment/getbyaptname", inputdata)
        .then((response) => {
          console.log("Response");
          console.log(response);
          if (response.data.status === "1") {
            console.log(response.data.data);
            if (response.data.data.length > 0) {
              if (edapartflg == true) isAddOrEdit = true;
              else isAddOrEdit = false;
            } else isAddOrEdit = true;
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal(" " + err.response.data.message, "", "warning", {
            timer: 2000,
            buttons: false,
          });
        });

      if (isAddOrEdit) {
        if (edapartflg == true) {
          var isResident;
          if (residentty == "Owner Occupied" || residentty == "Vacant")
            isResident = true;
          else isResident = false;

          if (residentty != "Owner Occupied") {
            setIsCurrentStay(false);
            currentStay = false;
          }

          inputdata = {
            apartment_id: aparteditid,
            building_id: 0,
            wing_id: 0,
            apartment_no: apartmentval,
            assigned_parking: parkingsloat,
            is_resident: isResident,
            uniq_apt_name: apartmentval,
            occupancy_type: residentty,
            is_current_stay: currentStay,
            resident_id: localStorage.getItem("residentid"),
          };
          setShowLoader(true);
          await makePostRequest("apartment/update", inputdata)
            .then((response) => {
              if (response.data.status === "1") {
                setaptar([...aptar, response.data.data.apartment_id]);

                swal("Success", "Bungalow Updated Successfully", "success", {
                  timer: 3000,
                  buttons: false,
                });

                setapartmentval("");
                setaparteditid("");
                // setwingval("");
                // setbuildingval("");
                setresidentty("");
                setparkingsloat("");
                setedapartflg(false);
                setUniqAptName("");
                viewresident();
                // setExpanded(false);
              }
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              swal(" " + err.response.data.message, "", "warning", {
                timer: 2000,
                buttons: false,
              });
            });
        } else {
          // setUpload(!Upload);
          if (flat_cnt == 0) {
            swal("please add Bunglow count");
          } else if (flat_cnt > cnt_mng) {
            setcnt_mng(cnt_mng + 1);
            var isResident;
            if (residentty == "Owner Occupied" || residentty == "Vacant")
              isResident = true;
            else isResident = false;

            if (residentty != "Owner Occupied") {
              setIsCurrentStay(false);
              currentStay = false;
            }

            inputdata = {
              building_id: 0,
              wing_id: 0,
              apartment_no: apartmentval,
              assigned_parking: parkingsloat,
              is_resident: isResident,
              uniq_apt_name: apartmentval,
              resident_id: localStorage.getItem("residentid"),
              occupancy_type: residentty,
              is_current_stay: currentStay,
            };
            setShowLoader(true);
            await makePostRequest("apartment/insert", inputdata)
              .then((response) => {
                if (response.data.status === "1") {
                  let aptRes = response.data.data;

                  if (propsResidentId > 0) {
                    aprtlistedit.push(response.data.data.apartment_id);
                    setaprtlistedit(aprtlistedit);
                  } else {
                    aptar.push(response.data.data.apartment_id);
                    setaptar(aptar);
                  }

                  apartmentlist.push(aptRes);
                  setapartmentlist(apartmentlist);

                  if (!wingList.includes(0)) {
                    wingList.push(0);
                    setWingList(wingList);
                  }

                  if (!buildingList.includes(0)) {
                    buildingList.push(0);
                    setBuildingList(buildingList);
                  }

                  lstUniqAptNames.push(response.data.data.uniq_apt_name);
                  setLstUniqAptNames(lstUniqAptNames);
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal(" " + err.response.data.message, "", "warning", {
                  timer: 2000,
                  buttons: false,
                });
              });

            // Code to update aprtment,building, wing details in Resident Details
            // Start======

            let residentData = {
              resident_id: localStorage.getItem("residentid"),
            };

            if (propsResidentId > 0) {
              residentData.apartment_id_list = aprtlistedit;
            } else {
              residentData.apartment_id_list = aptar;
            }
            residentData.uniq_apt_name = lstUniqAptNames;
            residentData.wing_ids_list = wingList;
            residentData.building_ids_list = buildingList;
            residentData.user_type = "Resident User";
            if (isResident) residentData.user_type = "Resident User";

            await makePostRequest("resident/update", residentData)
              .then((res) => {
                // checked codition if responce is empty
                console.log("Apart Update Resident Update ", res);
                if (res.data.data !== undefined) {
                }

                setShowLoader(false);
                setShowFamVehAccordian(true);

                setapartmentval("");
                setwingval("");
                setbuildingval("");
                setparkingsloat("");
                setresidentty("");
                setUniqAptName("");
              })
              .catch((err) => {
                swal("There was an error!", err, "warning");
              });
            //==End ================
            if (flat_cnt > apartmentlist.length) {
              const optionSelected = await swal({
                title: "Bunglow added successfully",
                text: "Do you want to add one more Bunglow?",
                icon: "success",
                dangerMode: true,
                buttons: ["No", "Yes, add one more"],
              });

              console.log(optionSelected);
              if (optionSelected) {
                if (flat_cnt > cnt_mng) {
                  setExpanded("panel1");
                } else {
                  swal(
                    " Your Maximum Bunglow Already Added",
                    "Not Able To Allocate More Bunglow",
                    "warning"
                  );
                  setExpanded("panel2");
                  swal("Success", "Please Add Family Members", "success", {
                    timer: 2000,
                    buttons: false,
                  });
                }
              } else {
                setExpanded("panel2");
                swal("Success", "Please Add Family Members", "success", {
                  timer: 2000,
                  buttons: false,
                });
              }
            } else {
              swal(
                " Your Maximum Bunglow Already Allocated",
                "Not Able To Allocate More Bunglow",
                ""
              );
              setExpanded("panel2");
              if (edapartflg == false) {
                swal("Success", "Please Add Family Members", "success", {
                  timer: 3000,
                  buttons: false,
                });
              }
            }
          } else {
            swal(
              " Your Maximum Bunglow Already Allocated",
              "Not Able To Allocate More Bunglow",
              "warning"
            );
            setapartmentval("");
            setwingval("");
            setbuildingval("");
            setparkingsloat("");
            setresidentty("");
          }
        }
        // GetTenentOccupiedBuildingList(localStorage.getItem("residentid"));
        GetTenentOccupiedAptmtLength();
      } else {
        setApartNameErrMsg("Bunglow already exist with same name.");
      }
    }
  }

  async function GetFamilyMemAllocatedApartments() {
    setFamilyMemAptList([]);
    var tempApt = [];
    // console.log("Family Memeber Apartment List ");
    // console.log(familyMemAptList);
    for (var i = 0; i < apartmentlist.length; i++) {
      if (apartmentlist[i].occupancy_type == "Owner Occupied") {
        tempApt.push(apartmentlist[i]);
        // console.log("Value of i "+i);
        // console.log(familyMemAptList)
      }
    }
    setFamilyMemAptList(tempApt);
  }
  const [allbuilding, setallbuilding] = React.useState([]);

  async function buildinglist() {
    var bodyFormData = new FormData();
    await makeGetRequest(
      "building/getall/" + localStorage.getItem("socityid"),
      bodyFormData
    )
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data.rows;
          setallbuilding(data1);
        } else {
          setallbuilding([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });
  }

  const [allwing, setallwing] = React.useState([]);

  async function winglisting(id) {
    var bodyFormData = new FormData();
    await makeGetRequest("wing/getbybuildingid/" + id, bodyFormData)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          setallwing(data1);
          // setwingval("")
        } else {
          setallwing([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });
  }

  const [allapartment, setallapartment] = React.useState([]);
  const [aptmtListByResident, setAptmtListByResident] = React.useState([]);
  const [buildListByResident, setBuildListByResident] = React.useState([]);
  const [wingListByResident, setWingListByResident] = React.useState([]);
  const [tenentAptName, setTenentAptName] = React.useState("");

  const [tenentOccupiedAptmtCnt, setTenentOccupiedAptmtCnt] = React.useState(0);
  const [tempAptCnt, setTempAptCnt] = React.useState(0);

  const handlechangTenentApartment = (e) => {
    setTenentApartment(e.target.value.toString());
    try {
      let idx = e.target.selectedIndex;
      // alert(idx)
      let dataset = e.target.options[idx].dataset;
      // alert(dataset)

      let selectedApt = dataset.isd;
      // alert(selectedApt);
      let tempName;
      if (localStorage.getItem("buildingCnt") > 0)
        tempName = tenentSelBuild + "/" + tenentSelWing + "/" + selectedApt;
      else tempName = selectedApt;

      setTenentAptName(tempName);
    } catch (e) {}
  };

  async function GetTenentOccupiedApartmentList(e) {
    setTenentWing(e.target.value);
    var residentId = localStorage.getItem("residentid");
    // alert(tenentBuilding);

    var bodyFormData = new FormData();
    await makeGetRequest(
      "apartment/gettenentoccupied/" +
        tenentBuilding +
        "/" +
        e.target.value +
        "/" +
        residentId,
      bodyFormData
    )
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          setAptmtListByResident(data1);
        } else {
          setAptmtListByResident([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });

    try {
      let idx = e.target.selectedIndex;
      let dataset = e.target.options[idx].dataset;
      let selectedWing = dataset.isd;

      setTenentSelWing(selectedWing);
    } catch (e) {}
  }

  async function GetTenentOccupiedBuildingList() {
    var bodyFormData = new FormData();
    var residentId = localStorage.getItem("residentid");
    await makeGetRequest(
      "building/gettenentoccupied/" + residentId,
      bodyFormData
    )
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          console.log(data1);
          setBuildListByResident(data1);
          setUpload(!upload);
        } else {
          setBuildListByResident([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });
  }

  const [tenentSelBuild, setTenentSelBuild] = React.useState("");
  const [tenentSelWing, setTenentSelWing] = React.useState("");

  async function GetTenentOccupiedWingList(e) {
    setTenentBuilding(e.target.value);
    var residentId = localStorage.getItem("residentid");
    var bodyFormData = new FormData();
    await makeGetRequest(
      "wing/gettenentoccupied/" + e.target.value + "/" + residentId,
      bodyFormData
    )
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          setWingListByResident(data1);
        } else {
          setWingListByResident([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });

    try {
      let idx = e.target.selectedIndex;
      let dataset = e.target.options[idx].dataset;
      let selectedBuild = dataset.isd;
      setTenentSelBuild(selectedBuild);
      // let tempName = selectedBuild + "/";
      // setTenentAptName(tempName);
      // alert('Wing '+tempName);
    } catch (e) {}
  }

  async function GetTenentOccupiedAptmtLength() {
    var residentId = localStorage.getItem("residentid");
    // alert("ResidentId"+residentId);

    if (residentId) {
      setShowLoader(true);
      await makeGetRequest("apartment/gettenentoccupied/0/0/" + residentId)
        .then((response) => {
          console.log("Apartment Response", response);

          if (response.data.status === "1") {
            var data1 = response.data.data;
            var aptCnt = data1.length;
            console.log("Apartment Occupied", aptCnt);
            setTenentOccupiedAptmtCnt(aptCnt);
            setShowLoader(false);
          }
        })
        .catch((err) => {
          swal("There was an error!", err, "warning");
        });
    }
  }

  async function apartmentlisting(buildid, wingid) {
    setShowLoader(true);
    await makeGetRequest("apartment/getnames/" + buildid + "/" + wingid)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;

          let editApartNo = localStorage.getItem("editApartNo");
          let isEditApartment = localStorage.getItem("isEditApartment");

          if (isEditApartment == "true") {
            data1.push(editApartNo);
          }
          console.log("Data 1" + data1);
          setallapartment(data1);
        } else {
          setallapartment([]);
        }
        setShowLoader(false);
        localStorage.removeItem("editApartNo");
        localStorage.removeItem("isEditApartment");
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", err, "warning");
      });
  }

  //all vehiclelisting
  async function vehiclelisting(residentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "vehicle/getbyresidentuser/" + residentId + "/false",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          // setloading(false)
          // alert("Vehicle Listing")
          console.log(response.data.data);
          setlengthvehi(response.data.data.length);
          setvehilisting(response.data.data);

          // setformsgdisplay(true)
        } else {
          // setloading(false)
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", err, "warning");
      });
  }
  //all familimemlisting
  async function familimemlisting(residentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "familymember/getbyresidentuser/" + residentId + "/false",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          setlengthfam(response.data.data.length);
          setfamlisting(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", err, "warning");
      });
  }

  //all familimemlisting
  async function GetTenentFamiliMemList(tenentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "familymember/getbyresidentuser/" + tenentId + "/true",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log("Family Member ", response.data.data);
          setTenentFamMemlength(response.data.data.length);
          setTenentFamMemList(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.messageupload, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", err, "warning");
      });
  }

  //Get Tenent Vehicle List
  async function GetTenentVehicleList(tenentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "vehicle/getbyresidentuser/" + tenentId + "/true",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          setTenentVehicleList(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", err, "warning");
      });
  }

  const navigate = useNavigate();
  if (propsResidentId > 0) {
    var formikInitials = {
      firstname: firstname,
      lastname: lastname,
      contact: contact,
      email: email,
      age: age,
      family_mem_cnt: family_mem_cnt,
      flat_cnt: flat_cnt,
    };
  } else {
    var formikInitials = {
      firstname: "",
      lastname: "",
      contact: "",
      email: "",
      age: "",
      family_mem_cnt: "",
      flat_cnt: "",
    };
  }

  var formikInitials_tents = {
    firstname_tents: firstname_tents,
    lastname_tents: lastname_tents,
    contact_tents: contact_tents,
    email_tents: email_tents,
    building_id: tenentBuilding,
    wing_id: tenentWing,
    apartment_id: tenentApartment,
    family_member: family_member,
    tenent_age: tenent_age,
  };

  var formikInitials_family = {
    fam_firstname: fam_firstname,
    fam_lastname: fam_lastname,
    fam_contact: fam_contact,
    fam_email: fam_email,
    fam_age: fam_age,
    relation: relation,
    // fam_apartment_no: fam_apartment_no,
  };

  var formikInitials_Tenentfamily = {
    fName_TenentFam: fName_TenentFam,
    lName_TenentFam: lName_TenentFam,
    contact_TenentFam: contact_TenentFam,
    email_TenentFam: email_TenentFam,
    age_TenentFam: age_TenentFam,
    relation_TenentFam: relation_TenentFam,
  };

  // if(edvehiflg){
  //   var formikInitials_vehicle = {
  //     vehicleType:vehicleType,
  //     ownername: ownername,
  //     registrationno: registrationno,
  //     vehicleno: vehicleno,
  //   };
  // }
  // else{
  var formikInitials_vehicle = {
    // vehicleType:"",
    ownername: ownername,
    registrationno: registrationno,
    vehicleno: vehicleno,
  };
  // }

  var formikInitials_TenentVehicle = {
    tenentV_OwnerName: tenentV_OwnerName,
    tenentV_RegNo: tenentV_RegNo,
    tenentVehicleNo: tenentVehicleNo,
  };

  async function GetAptmtByResidentId(residentId) {
    await makeGetRequest("apartment/getbyresidentid/" + residentId)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          console.log(data1);
          setapartmentlist([]);
          apartmentlist = response.data.data;
          setapartmentlist(apartmentlist);
        } else {
          setapartmentlist([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });
  }

  //vehicle delete
  async function deletevehicle(id) {
    // alert(localStorage.getItem("isTenent"));

    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete this record? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      setShowLoader(true);
      await makeGetRequest("vehicle/delete/" + id)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });

            if (localStorage.getItem("isTenent")) {
              GetTenentVehicleList(localStorage.getItem("tenentId"));
              cancelTenentVehicle();
            } else {
              vehiclelisting(localStorage.getItem("residentid"));
              handleCancelVehicle();
            }
            setShowLoader(false);
          } else {
            setShowLoader(false);
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", err, "warning");
        });
    }
  }
  //vehicle edit
  const [vehicleeditid, setvehicleeditid] = React.useState("");
  const [vehicleReseditid, setVehicleReseditid] = React.useState("");
  const [edvehiflg, setedvehiflg] = React.useState(false);
  const [vehicleType, setVehicleType] = React.useState("");
  const [tenentVehicleType, setTenentVehicleType] = React.useState("");
  const [tenentVehicleReseditid, setTenentVehicleReseditid] =
    React.useState("");

  async function editvehicle(id) {
    // alert("Edit Vehicle");
    setedvehiflg(true);
    setvehicleeditid(id);
    let inputdata = {};
    await makeGetRequest("vehicle/getbyid/" + id, inputdata).then(
      (response) => {
        setownername(response.data.data.vehicle_owner_name);
        setregistrationno(response.data.data.reg_no);
        setvehicleno(response.data.data.vehicle_no);
        setVehicleType(response.data.data.vehicle_type);
        setVehicleDocumentsList(response.data.data.document_list);
        setVehicleReseditid(response.data.data.residenent_user_id);
      }
    );
  }

  async function handleCancelVehicle() {
    setedvehiflg(false);
    setvehicleeditid("");
    setownername("");
    setregistrationno("");
    setvehicleno("");
    setVehicleType("");
    setVehicleDocumentsList("");
    setVehicleReseditid("");
  }

  //Tenent vehicle edit
  const [tenentVehicleEditId, setTenentVehicleEditId] = React.useState("");
  const [tenentVehicleEditFlg, setTenentVehicleEditFlg] = React.useState(false);

  async function cancelTenentVehicle() {
    setTenentVehicleEditFlg(false);
    setTenentVehicleEditId("");
    setTenentVOwnerName("");
    setTenentVRegNo("");
    setTenentVehicleNo("");
    setTenentVehicleType("");
    setTenentVehicleDocList("");
    setTenentVehicleReseditid("");
  }

  async function editTenentVehicle(id) {
    setTenentVehicleEditFlg(true);
    setTenentVehicleEditId(id);
    let inputdata = {};
    await makeGetRequest("vehicle/getbyid/" + id, inputdata).then(
      (response) => {
        // alert("Response " + response.data.data.vehicle_owner_name);
        setTenentVOwnerName(response.data.data.vehicle_owner_name);
        setTenentVRegNo(response.data.data.reg_no);
        setTenentVehicleNo(response.data.data.vehicle_no);
        setTenentVehicleType(response.data.data.vehicle_type);
        setTenentVehicleDocList(response.data.data.document_list);
        setTenentVehicleReseditid(response.data.data.residenent_user_id);
      }
    );
  }

  //Family member edit
  const [familyeditid, setfamilyeditid] = React.useState("");
  const [edfamilyflg, setedfamilyflg] = React.useState(false);

  async function editfamilymember(id) {
    setedfamilyflg(true);
    setfamilyeditid(id);
    let inputdata = {};
    await makeGetRequest("familymember/getbyid/" + id, inputdata).then(
      (response) => {
        setfam_firstname(response.data.data.user_obj.first_name);
        setfam_lastname(response.data.data.user_obj.last_name);
        setfam_contact(response.data.data.user_obj.contact_no);
        setfam_email(response.data.data.user_obj.email_id);
        setfam_age(response.data.data.user_obj.age);
        setrelation(response.data.data.relation);
        setFamMemberProfPic(response.data.data.user_obj.profile_pic);
        setFamMemAptmtNo(response.data.data.apartment_no);
        setFamAPtmtId(response.data.data.apartment_id);
      }
    );
  }

  async function handleCancelFamMem() {
    setedfamilyflg(false);
    setfamilyeditid("");
    setfam_firstname("");
    setfam_lastname("");
    setfam_contact(contact);
    setfam_email(email);
    setfam_age("");
    setrelation("");
    setFamMemberProfPic("");
    setFamMemAptmtNo("");
    setFamAPtmtId("");
  }

  //Tenent Family member edit
  const [tenentFamilyEditId, setTenentFamilyEditId] = React.useState("");
  const [edTenentFamilyFlag, setEdTenentFamilyFlag] = React.useState(false);

  async function editTenentFamilyMember(id) {
    setTenentFamilyEditId(id);
    setEdTenentFamilyFlag(true);
    let inputdata = {};

    await makeGetRequest("familymember/getbyid/" + id, inputdata).then(
      (response) => {
        setFName_TenentFam(response.data.data.user_obj.first_name);
        setlName_TenentFam(response.data.data.user_obj.last_name);
        setContact_TenentFam(response.data.data.user_obj.contact_no);
        setEmail_TenentFam(response.data.data.user_obj.email_id);
        setAge_TenentFam(response.data.data.user_obj.age);
        setRelation_TenentFam(response.data.data.relation);
        setTenentFamMemberProfPic(response.data.data.user_obj.profile_pic);
      }
    );
  }

  //family memeber delete
  async function deletefamilymember(id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete this record? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      await makeGetRequest("familymember/delete/" + id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });

            if (localStorage.getItem("isTenent")) {
              GetTenentFamiliMemList(localStorage.getItem("tenentId"));
              cancelTenentFamMem();
            } else {
              familimemlisting(localStorage.getItem("residentid"));
              handleCancelFamMem();
            }
          } else {
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          swal("There was an error!", err, "warning");
        });
    }
  }

  //delete apartment
  async function deleteapartment(id) {
    let isDeleted = false;
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete this record? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      setShowLoader(true);
      var bodyFormData = new FormData();
      await makeGetRequest("apartment/delete/" + id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            isDeleted = true;

            setcnt_mng(cnt_mng - 1);
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            // viewresident();
          } else {
            swal("Error", "Failed to delete", "error");
            setShowLoader(false);
          }
        })
        .catch((err) => {
          swal("There was an error!", err, "warning");
          setShowLoader(false);
        });
    }

    if (isDeleted) {
      await makeGetRequest("apartment/getbyresidentid/" + propsResidentId)
        .then((response) => {
          if (response.data.status === "1") {
            var data1 = response.data.data;
            console.log(data1);
            // setapartmentlist([]);
            // for(var i=0;i<response.data.data.length;i++)
            // {
            //   apartmentlist.push(response.data.data);
            // }
            setapartmentlist(response.data.data);
          } else {
            setapartmentlist([]);
          }
        })
        .catch((err) => {
          swal("There was an error!", err, "warning");
        });
      setShowLoader(false);
    }
  }

  //edit apartment
  const [aparteditid, setaparteditid] = React.useState("");
  const [edapartflg, setedapartflg] = React.useState(false);

  async function editapartment(id, isResident, uniq_apt_name) {
    console.log("uniq_apt_name",uniq_apt_name)
    setaparteditid(id);
    setedapartflg(true);
    setShowLoader(true);
    let isEditable = false;

    if (isResident == true) {
      isEditable = true;
    } else {
      let inputdata = {
        residentId: propsResidentId,
        uniqAptName: uniq_apt_name,
      };
      await makePostRequest("apartment/isAptmtEditable/", inputdata).then(
        (response) => {
          if (response.data.data.length > 0) {
            isEditable = false;
          } else isEditable = true;
        }
      );
    }
    if (isEditable) {
      await makeGetRequest("apartment/getbyid/" + id).then((response) => {
        if (response.data.data != undefined) {
          apartmentlisting(
            response.data.data.building_id,
            response.data.data.wing_id
          );
          setapartmentval(response.data.data.apartment_no);

          winglisting(response.data.data.building_id);
          setwingval(response.data.data.wing_id);
          setbuildingval(response.data.data.building_id);

          setparkingsloat(response.data.data.assigned_parking);
          setIsCurrentStay(response.data.data.is_current_stay);
          localStorage.setItem("editApartNo", response.data.data.apartment_no);
          localStorage.setItem("isEditApartment", true);

          // if (response.data.data.is_resident)
          // setresidentty("Owner");
          // else setresidentty("Tenents");
          setresidentty(response.data.data.occupancy_type);

          let element = document.getElementById("residentTypeList");

          if (response.data.data.is_resident) element.value = "Owner";
          else element.value = "Tenents";
          setShowLoader(false);
        }
      });
    } else {
      {
        localStorage.getItem("buildingCnt") > 0
          ? swal(
              "Warning",
              "Apartment already allocated to tenant, not able to update data",
              "warning",
              {
                timer: 3000,
                buttons: false,
              }
            )
          : swal(
              "Warning",
              "Bunglow already allocated to tenant, not able to update data",
              "warning",
              {
                timer: 3000,
                buttons: false,
              }
            );

        setaparteditid("");
        setedapartflg(false);
      }
      setShowLoader(false);
    }
  }

  //edit tentes

  const [tenentEditId, setTenentEditId] = React.useState("");
  const [edtentsflg, setedtentsflg] = React.useState(false);
  const [hidetenentFamVehDiv, setHideTenentFamVehDiv] = React.useState(false);

  async function cancelTenentFamMem() {
    setTenentFamilyEditId("");
    setEdTenentFamilyFlag(false);
    setFName_TenentFam("");
    setlName_TenentFam("");
    // setContact_TenentFam("");
    // setEmail_TenentFam("");
    setEmail_TenentFam(email_tents);
    setContact_TenentFam(contact_tents);
    setAge_TenentFam("");
    setRelation_TenentFam("");
    setTenentFamMemberProfPic("");
  }

  async function edittents(id) {
    setTenentEditId(id);
    setedtentsflg(true);
    setExpanded("panel02");
    setHideTenentFamVehDiv(true);
    setShowLoader(true);

    let buildingid = "";
    await makeGetRequest("resident/getbyid/" + id).then((response) => {
      localStorage.setItem("tenentId", id);
      localStorage.setItem("isTenent", true);
      let tenentObj = response.data.data;

      // console.log("Edit tenent ");
      console.log(tenentObj);
      setfirstname_tents(tenentObj.user_obj.first_name);
      setlastname_tents(tenentObj.user_obj.last_name);
      setcontact_tents(tenentObj.user_obj.contact_no);
      setemail_tents(tenentObj.user_obj.email_id);
      setTenent_age(tenentObj.user_obj.age);
      setfamily_member(tenentObj.family_count);
      setTenentProfilePic(tenentObj.user_obj.profile_pic);
      setTenentDocumentsList(tenentObj.document_list);

      setTenentBuilding(tenentObj.building_ids_list[0]);
      buildingid = tenentObj.building_ids_list[0];
      console.log("Wing Id" + tenentObj.wing_ids_list[0]);
      // wingListByResident.push(tenentObj.wing_ids_list[0]);
      // setWingListByResident(tenentObj.wing_ids_list);
      setTenentWing(tenentObj.wing_ids_list[0]);

      setTenentApartment(tenentObj.apartment_id_list[0]);

      GetTenentFamiliMemList(id);
      GetTenentVehicleList(id);
      setShowLoader(false);
      document.getElementById("tenentBuildingList").disabled = false;
      document.getElementById("tenentWingList").disabled = false;
      document.getElementById("tenentAptList").disabled = false;
    });

    await makeGetRequest("building/getbyid/" + buildingid)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          console.log("Building data");
          console.log(data1);
          setBuildListByResident([]);
          buildListByResident.push(data1);
          setBuildListByResident(buildListByResident);
        } else {
          setBuildListByResident([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });

    await makeGetRequest("wing/getbybuildingid/" + buildingid)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          console.log("wing data");
          console.log(data1);
          setWingListByResident([]);
          setWingListByResident(data1);
        } else {
          setWingListByResident([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });

    await makeGetRequest("apartment/gettenentoccupied/0/0/" + id)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          setAptmtListByResident([]);
          setAptmtListByResident(data1);
        } else {
          setAptmtListByResident([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });

    document.getElementById("tenentBuildingList").disabled = true;
    document.getElementById("tenentWingList").disabled = true;
    document.getElementById("tenentAptList").disabled = true;
  }

  async function getTenentsListByResidentId() {
    let residentId = localStorage.getItem("residentid");
    if (residentId) {
      await makeGetRequest("resident/gettenantsbyresident/" + residentId)
        .then((response) => {
          if (response.data.status === "1") {
            // alert("Done");
            // console.log("API Res")
            // console.log(response.data.data[0]);

            setTenentslist(response.data.data);
            // return response.data.data;
            // viewresident();
          }
        })
        .catch((err) => {
          swal("There was an error!", err, "warning");
        });
    }
  }

  //tents delete
  async function deletetents(id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to release this tenant? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      let deleted = true;
      let tenentRes = [];
      await makeGetRequest("resident/delete/" + id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Tenent released successfully", "success", {
              timer: 1000,
              buttons: false,
            });

            deleted = true;
            // viewresident();
          }
        })
        .catch((err) => {
          swal("There was an error!", err, "warning");
        });
      // if(deleted)
      // {
      await getTenentsListByResidentId();
      setTenentDocErrorMsg("");
      localStorage.removeItem("tenentId");
      localStorage.removeItem("isTenent");
      localStorage.removeItem("tenentFamilyMemCnt");
      setfirstname_tents("");
      setlastname_tents("");
      setcontact_tents("");
      setemail_tents("");
      setTenentBuilding("");
      setTenentWing("");
      setTenentApartment("");
      setfamily_member("");
      setTenentProfilePic("");
      setTenentDocumentsList([]);
      setTenentAptName("");
      setTenent_age("");
      setExpanded(false);

      setTenentEditId("");
      setedtentsflg(false);

      setHideTenentFamVehDiv(false);
      GetTenentOccupiedBuildingList();

      document.getElementById("tenentBuildingList").disabled = false;
      document.getElementById("tenentWingList").disabled = false;
      document.getElementById("tenentAptList").disabled = false;

      //      console.log("Tenent Response ");
      //      console.log(tenentRes);
      //     setTenentslist(tenentRes);
      // }
    }
  }

  const [aptCntErrMsg, setAptCntErrMsg] = React.useState("");
  const [famMemErrMsg, setFamMemErrMsg] = React.useState("");

  //ad owner details
  async function addrecidency() {
    let tempResidentId;
    let isEmailContactExist = false;
    setAptCntErrMsg("");
    setFamMemErrMsg("");
    let resByContact = await getUserByContactNo(contact);

    // alert(resByContact);

    if (resByContact) {
      if (propsResidentId > 0 && resByContact.resident_id == propsResidentId) {
        setcontact(contact);
      } else {
        swal(
          "Contact No " +
            resByContact.user_obj.contact_no +
            " is already used by " +
            resByContact.user_obj.first_name +
            " " +
            resByContact.user_obj.last_name,
          "Please use another Contact No",
          "warning"
        );
        document.getElementById("contact").value = "";
        setcontact("");
        isEmailContactExist = true;
      }
    }

    if (isEmailContactExist == false) {
      let resByEmail = await getUserByEmailId(email);
      if (resByEmail) {
        // alert(propsResidentId);
        // alert(resByEmail.resident_id);

        if (propsResidentId > 0 && resByEmail.resident_id == propsResidentId) {
          setemail(email);
        } else {
          swal(
            "Email Id " +
              resByEmail.user_obj.email_id +
              " is already used by " +
              resByEmail.user_obj.first_name +
              " " +
              resByEmail.user_obj.last_name,
            "Please use another Email Id",
            "warning"
          );
          document.getElementById("email").value = "";
          isEmailContactExist = true;
        }
        setDocErrorMsg("");
      }
    }

    if (isEmailContactExist == false) {
      if (propsResidentId > 0) {
        let isEditUser = false;
        tempResidentId = propsResidentId;

        if (flat_cnt >= apartmentlist.length) {
          isEditUser = true;
          if (family_mem_cnt >= famlisting.length) {
            isEditUser = true;
          } else {
            setFamMemErrMsg("Invalid Family Member Count");
            isEditUser = false;
          }
        } else {
          setAptCntErrMsg("Invalid Apartment Count");
          isEditUser = false;
        }

        if (isEditUser) {
          let new_user_type;
          if(usertypechk==='SocietyAdmin' && flat_cnt>0) {
             new_user_type = "Admin Owner"
          }
          let inputdata = {
            resident_id: propsResidentId,
            user_obj: {
              first_name: firstname,
              last_name: lastname,
              age: age,
              contact_no: contact,
              email_id: email,
              profile_pic: profile_pic,
            },
            family_count: family_mem_cnt,
            apartment_count: flat_cnt,
            apartment_id_list: aprtlistedit,
            wing_ids_list: wingList,
            building_ids_list: buildingList,
            uniq_apt_name: lstUniqAptNames,
            // allocated_parking: 101,
            // guest_parking: 107,
            document_list: documentsList,
            // password: password,
            emergency_contact: isEmergencyContact,
            user_type: new_user_type
          };
          setShowLoader(true);
          await makePostRequest("resident/update", inputdata)
            .then((response) => {
              console.log("gautami")
              // checked codition if responce is empty
              if (response.data.data !== undefined) {
                localStorage.setItem("familyMemCnt", family_mem_cnt);
                swal("Success", "Resident Updated Successfully", "success", {
                  timer: 1000,
                  buttons: false,
                });

                setfam_email(response.data.data.user_obj.email_id);
                setfam_contact(response.data.data.user_obj.contact_no);
                console.log("Resident Updated Data");
                console.log(response.data.data);
                GetTenentOccupiedBuildingList(response.data.data.resident_id);
                GetTenentOccupiedAptmtLength();
                // GetTenentOccupiedWingList(response.data.data.resident_id);
                setExpanded(false);
                // window.location.reload();

                // navigate('/ResidentManagement')
                // a11yProps(1);
              } else {
              }
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              swal(" " + err.response.data.message, "", "warning", {
                timer: 2000,
                buttons: false,
              });
            });
        }
      } else {
        let userType = "";

        let newPass = firstname + "@" + contact.slice(0, 4);
        console.log("New Pass ", newPass);

        if (contact && email) {
          let inputdata = {
            society_id: localStorage.getItem("socityid"),
            user_obj: {
              first_name: firstname,
              last_name: lastname,
              age: age,
              contact_no: contact,
              email_id: email,
              profile_pic: profile_pic,
              profile_mode: "public",
            },
            family_count: family_mem_cnt,
            apartment_count: flat_cnt,
            apartment_id_list: aptar,
            wing_ids_list: wingList,
            building_ids_list: buildingList,
            uniq_apt_name: lstUniqAptNames,
            user_type: "Owner",
            document_list: documentsList,
            password: newPass,
            emergency_contact: isEmergencyContact,
            schema_name: sessionStorage.getItem("schema"),
            society_code: localStorage.getItem("societyCode"),
          };
          setShowLoader(true);
          await makePostRequest("resident/insert", inputdata)
            .then((response) => {
              if (response.data.data !== undefined) {
                tempResidentId = response.data.data.resident_id;
                localStorage.setItem(
                  "residentid",
                  response.data.data.resident_id
                );
                localStorage.setItem("familyMemCnt", family_mem_cnt);
                localStorage.setItem(
                  "residentName ",
                  response.data.data.user_obj.first_name +
                    " " +
                    response.data.data.user_obj.last_name
                );
                document.getElementById("email").setAttribute("readonly", true);

                // GetTenentOccupiedBuildingList(response.data.data.resident_id);

                // setfirstname("");
                // setlastname("");
                // setage("");
                // setcontact("");
                // setemail("");
                // formikInitials = {
                //   firstname: "",
                //   lastname: "",
                //   contact: "",
                //   email: "",
                //   age: "",
                //   family_mem_cnt: "",
                //   flat_cnt: "",
                // };

                setShowAptmtAccordian(true);
                setPropsResidentId(response.data.data.resident_id);
                setfam_email(response.data.data.user_obj.email_id);
                setfam_contact(response.data.data.user_obj.contact_no);
                swal(
                  "Resident Added Successfully",
                  "Please Add Apartment Details",
                  "success",
                  {
                    timer: 3000,
                    buttons: false,
                  }
                );
                setExpanded("panel1");
                // alert("Praops "+propsResidentId);
                // window.location.reload()
                // navigate('/ResidentManagement')
                // a11yProps(1);
              }
              setShowLoader(false);
            })
            .catch((err) => {
              swal(" " + err.message, "Please use other details", "warning");
            });
        }
        // else
        // {
        //   swal("Email or Contact No Is empty ", "Please Add Email and Contact No", "warning");
        // }
      }
      setDocErrorMsg("");
      setProfileErrMsg("");
    }
  }

  async function addTenentFamilymem(values, { resetForm }) {
    let tenentId;
    let familyMemCnt;
    let addedFamMemCnt = tenentFamMemList.length;

    tenentId = localStorage.getItem("tenentId");
    familyMemCnt = parseInt(localStorage.getItem("tenentFamilyMemCnt"));

    if (edTenentFamilyFlag == true) {
      let inputdata = {
        member_id: tenentFamilyEditId,
        user_obj: {
          first_name: fName_TenentFam,
          last_name: lName_TenentFam,
          age: age_TenentFam,
          contact_no: contact_TenentFam,
          email_id: email_TenentFam,
          profile_pic: tenentFamMemberProfPic,
        },
        relation: relation_TenentFam,
        residenent_user_id: tenentId,
        is_tenent: true,
      };
      setShowLoader(true);
      await makePostRequest("familymember/update", inputdata)
        .then((response) => {
          // checked codition if responce is empty
          if (response.data.data !== undefined) {
            GetTenentFamiliMemList(tenentId);
            // localStorage.setItem('residentid',response.data.data.resident_id)
            swal(
              "Success",
              "Family Member Information Updated Successfully",
              "success",
              {
                timer: 3000,
                buttons: false,
              }
            );

            resetForm({ values: "" });
            setFName_TenentFam("");
            setlName_TenentFam("");
            setAge_TenentFam("");
            setEmail_TenentFam(email_tents);
            setContact_TenentFam(contact_tents);
            setRelation_TenentFam("");
            setTenentFamMemberProfPic("");
            setEdTenentFamilyFlag(false);
            setTenentFamilyEditId("");

            formikInitials_Tenentfamily = {
              fName_TenentFam: "",
              lName_TenentFam: "",
              contact_TenentFam: "",
              email_TenentFam: "",
              age_TenentFam: "",
              relation_TenentFam: "",
            };

            // a11yProps(2);
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal(" " + err.response.data.message, "", "warning", {
            timer: 2000,
            buttons: false,
          });
        });
    } else {
      if (tenentFamMemList.length < family_member) {
        let inputdata = {
          user_obj: {
            first_name: fName_TenentFam,
            last_name: lName_TenentFam,
            age: age_TenentFam,
            contact_no: contact_TenentFam,
            email_id: email_TenentFam,
            profile_pic: tenentFamMemberProfPic,
          },
          relation: relation_TenentFam,
          residenent_user_id: tenentId,
          is_tenent: true,
        };
        setShowLoader(true);

        await makePostRequest("familymember/insert", inputdata)
          .then((response) => {
            // checked codition if responce is empty
            if (response.data.data !== undefined) {
              GetTenentFamiliMemList(tenentId);
              addedFamMemCnt = addedFamMemCnt + 1;
              // resetForm({ values: "" });
              setFName_TenentFam("");
              setlName_TenentFam("");
              setAge_TenentFam("");
              setEmail_TenentFam(email_tents);
              setContact_TenentFam(contact_tents);
              setRelation_TenentFam("");
              setTenentFamMemberProfPic("");

              formikInitials_Tenentfamily = {
                fName_TenentFam: "",
                lName_TenentFam: "",
                contact_TenentFam: "",
                email_TenentFam: "",
                age_TenentFam: "",
                relation_TenentFam: "",
              };
              swal("Success", "Family Member Added Successfully", "success", {
                timer: 3000,
                buttons: false,
              });
              // window.location.reload()

              // a11yProps(2);
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal(" " + err.response.data.message, "", "warning", {
              timer: 2000,
              buttons: false,
            });
          });

        if (family_member > addedFamMemCnt) {
          const optionSelected = await swal({
            title: "Family Member Added Successfully",
            text: "Do you want to add other family member?",
            icon: "success",
            dangerMode: true,
            buttons: ["No", "Yes, add one more"],
          });
          console.log(optionSelected);
          if (optionSelected) {
            setExpanded("panel03");
          } else {
            setExpanded("panel04");
            swal("Success", "Please Add Vehicle Details", "success", {
              timer: 2000,
              buttons: false,
            });
          }
        } else {
          setExpanded("panel3");
          if (edfamilyflg == false) {
            swal(
              "All Family Members Added",
              "Please add vehicle details",
              "success",
              {
                timer: 2000,
                buttons: false,
              }
            );
          }
        }
      } else {
        swal("All Family Member Already Added");
      }
    }
  }

  const [selectApmtErrMsg, setSelectApmtErrMsg] = React.useState("");

  async function addfamilymem() {
    setSelectApmtErrMsg("");
    alert(fam_apartment_no);
    if (fam_apartment_no == "") {
      setSelectApmtErrMsg("Please select apartment");
    } else {
      var residentId;
      let addedFamMemCnt = famlisting.length;
      if (edfamilyflg == true) {
        let inputdata = {
          member_id: familyeditid,
          user_obj: {
            first_name: fam_firstname,
            last_name: fam_lastname,
            age: fam_age,
            contact_no: fam_contact,
            email_id: fam_email,
            profile_pic: famMemberProfPic,
          },
          relation: relation,
          residenent_user_id: propsResidentId,
          apartment_id: fam_Aptmt_Id,
          apartment_no: fam_apartment_no,
          is_tenent: false,
        };
        setShowLoader(true);
        await makePostRequest("familymember/update", inputdata)
          .then((response) => {
            // checked codition if responce is empty
            if (response.data.data !== undefined) {
              familimemlisting(propsResidentId);
              // localStorage.setItem('residentid',response.data.data.resident_id)
              swal(
                "Success",
                "Family Information Updated Successfully",
                "success",
                {
                  timer: 1000,
                  buttons: false,
                }
              );
              // resetForm({ values: "" });
              setfam_firstname("");
              setfam_lastname("");
              setfam_age("");
              setfam_contact(contact);
              setfam_email(email);
              setrelation("");
              setFamMemberProfPic("");
              setFamMemAptmtNo("");
              setFamAPtmtId("");
              setedfamilyflg(false);
              setfamilyeditid("");

              formikInitials_family = {
                fam_firstname: "",
                fam_lastname: "",
                fam_contact: "",
                fam_email: "",
                fam_age: "",
                relation: "",
              };
              // setExpanded(false);
              // a11yProps(2);
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal(" " + err.response.data.message, "", "warning", {
              timer: 2000,
              buttons: false,
            });
          });
        // }
        // else{
        //   swal("All family member added alerady");
        // }
        // }
      } else {
        if (family_mem_cnt > famlisting.length) {
          if (propsResidentId > 0) {
            residentId = propsResidentId;
          } else {
            residentId = localStorage.getItem("residentid");
          }
          let inputdata = {
            user_obj: {
              first_name: fam_firstname,
              last_name: fam_lastname,
              age: fam_age,
              contact_no: fam_contact,
              email_id: fam_email,
              profile_pic: famMemberProfPic,
            },
            relation: relation,
            residenent_user_id: residentId,
            is_tenent: false,
            apartment_id: fam_Aptmt_Id,
            apartment_no: fam_apartment_no,
          };
          setShowLoader(true);
          await makePostRequest("familymember/insert", inputdata)
            .then((response) => {
              // checked codition if responce is empty
              if (response.data.data !== undefined) {
                familimemlisting(residentId);
                // localStorage.setItem('residentid',response.data.data.resident_id)
                addedFamMemCnt = addedFamMemCnt + 1;
                // resetForm({ values: "" });
                setfam_firstname("");
                setfam_lastname("");
                setfam_age("");
                setfam_contact(contact);
                setfam_email(email);
                setrelation("");
                setFamMemberProfPic("");
                setFamMemAptmtNo("");
                setFamAPtmtId("");

                formikInitials_family = {
                  fam_firstname: "",
                  fam_lastname: "",
                  fam_contact: "",
                  fam_email: "",
                  fam_age: "",
                  relation: "",
                };

                // if(family_mem_cnt == addedFamMemCnt)
                // {
                //     document.getElementById('addfamiltbtn').disabled=true;
                // }
                // window.location.reload()

                // a11yProps(2);
              } else {
              }
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              swal(" " + err.response.data.message, "", "warning", {
                timer: 2000,
                buttons: false,
              });
            });

          // alert(family_mem_cnt)
          // alert(famlisting.length)
          // {edfamilyflg==''}
          if (family_mem_cnt > addedFamMemCnt) {
            const optionSelected = await swal({
              title: "Family Member Added Successfully",
              text: "Do you want to add other family member?",
              icon: "success",
              dangerMode: true,
              buttons: ["No", "Yes, add one more"],
            });
            console.log(optionSelected);
            if (optionSelected) {
              setExpanded("panel2");
            } else {
              setExpanded("panel3");
              swal("Success", "Please Add Vehicle Details", "success", {
                timer: 2000,
                buttons: false,
              });
            }
          } else {
            setExpanded("panel3");
            if (edfamilyflg == false) {
              swal(
                "All Family Members Added",
                "Please add vehicle details",
                "success",
                {
                  timer: 2000,
                  buttons: false,
                }
              );
            }
          }
        } else {
          swal("All Family Members Added", "", "info");
        }
      }
    }
  }

  //add tents

  async function cancelTenent() {
    const optionSelected = await swal({
      title: "Add New Tenant",
      text: "Would you like to add new tenant?",
      icon: "warning",
      dangerMode: true,
      // buttons: true,
      // confirmButtonText: "Yes",
      // cancelButtonText: "No"
      buttons: ["No, cancel it!", "Yes, I am sure!"],
    });

    console.log(optionSelected);
    if (optionSelected) {
      setTenentDocErrorMsg("");
      localStorage.removeItem("tenentId");
      localStorage.removeItem("isTenent");
      localStorage.removeItem("tenentFamilyMemCnt");
      setfirstname_tents("");
      setlastname_tents("");
      setcontact_tents("");
      setemail_tents("");
      setTenentBuilding("");
      setTenentWing("");
      setTenentApartment("");
      setfamily_member("");
      setTenentProfilePic("");
      setTenentDocumentsList([]);
      setTenentAptName("");
      setTenent_age("");

      GetTenentOccupiedBuildingList();

      setWingListByResident([]);
      setAptmtListByResident([]);

      setExpanded(false);

      setTenentEditId("");
      setedtentsflg(false);

      document.getElementById("tenentBuildingList").disabled = false;
      document.getElementById("tenentWingList").disabled = false;
      document.getElementById("tenentAptList").disabled = false;

      setTenentFamMemList([]);
      cancelTenentFamMem();
      setTenentVehicleList([]);

      setHideTenentFamVehDiv(false);
      setExpanded("panel02");
    }
  }

  const [tenentFamMemErrMsg, setTenentFamMemErrMsg] = React.useState("");

  // async function addTenent() {
  async function addTenent() {
    // alert("In Tenent Section");
    let isEmailContactExist = false;
    setTenentFamMemErrMsg("");

    let resByContact = await getUserByContactNo(contact_tents);

    if (resByContact != "") {
      setShowLoader(true);
      //This condition is checked if we are editing the tenent keeping
      if (tenentEditId > 0 && tenentEditId == resByContact.resident_id) {
        setcontact_tents(contact_tents);
      } else {
        swal(
          "Contact No " +
            resByContact.user_obj.contact_no +
            " is already used by " +
            resByContact.user_obj.first_name +
            " " +
            resByContact.user_obj.last_name,
          "Please use another Contact No",
          "warning"
        );
        document.getElementById("contact_tents").value = "";
        setcontact_tents("");
        isEmailContactExist = true;
      }
      setShowLoader(false);
    }

    if (isEmailContactExist == false) {
      let resByEmail = await getUserByEmailId(email_tents);
      if (resByEmail != "") {
        if (tenentEditId > 0 && tenentEditId == resByEmail.resident_id) {
          setemail_tents(email_tents);
        } else {
          swal(
            "Email Id " +
              resByEmail.user_obj.email_id +
              " is already used by " +
              resByEmail.user_obj.first_name +
              " " +
              resByEmail.user_obj.last_name,
            "Please use another Email Id",
            "warning"
          );
          document.getElementById("email_tents").value = "";
          isEmailContactExist = true;
        }
      }
    }

    if (isEmailContactExist == false) {
      let tenentApartmentIdList = [];
      let tenentBuildLst = [];
      let tenentWingLst = [];
      let uniqAptLst = [];

      if (edtentsflg == true) {
        // alert(localStorage.getItem("residentid"));
        setShowLoader(true);

        let isEditUser = false;
        if (family_member >= tenentFamMemList.length) {
          isEditUser = true;
        } else {
          setTenentFamMemErrMsg("Invalid Family Member Count");
          isEditUser = false;
        }
        setShowLoader(false);

        if (isEditUser) {
          setShowLoader(true);

          if (localStorage.getItem("buildingCnt") == 0) {
            tenentApartmentIdList.push(parseInt(tenentApartment));
            tenentBuildLst.push(0);
            tenentWingLst.push(0);
            uniqAptLst.push(tenentAptName);
            setTempAptCnt(cnt);
          } else {
            tenentApartmentIdList.push(parseInt(tenentApartment));
            tenentBuildLst.push(parseInt(tenentBuilding));
            tenentWingLst.push(parseInt(tenentWing));
            uniqAptLst.push(tenentAptName);
            setTempAptCnt(cnt);
          }

          let inputdata = {
            resident_id: tenentEditId,
            residenent_user_id: propsResidentId,
            user_obj: {
              first_name: firstname_tents,
              last_name: lastname_tents,
              contact_no: contact_tents,
              email_id: email_tents,
              profile_pic: tenentProfilePic,
              age: tenent_age,
              profile_mode: "public",
            },
            // building_ids_list: tenentBuildLst,
            // wing_ids_list: tenentWingLst,
            // apartment_id_list: tenentApartmentIdList,
            family_count: family_member,
            document_list: tenentDocumentsList,
            // uniq_apt_name: uniqAptLst,
          };

          await makePostRequest("resident/update", inputdata)
            .then((response) => {
              // checked codition if responce is empty
              if (response.data.data !== undefined) {
                let tenentUpdatedRes = response.data.data.res.rows[0];
                console.log("Tenent Updated Data");
                console.log(response.data.data.res.rows[0]);
                // setedtentsflg(false);
                // setExpanded(false);
                viewresident();
                GetTenentFamiliMemList(tenentEditId);
                GetTenentVehicleList(tenentEditId);

                swal("Success", "Tenant updated successfully", "success", {
                  timer: 3000,
                  buttons: false,
                });
                localStorage.setItem("isTenent", true);
                // alert(tenentUpdatedRes.resident_id)
                localStorage.setItem("tenentId", tenentUpdatedRes.resident_id);
                localStorage.setItem(
                  "tenentFamilyMemCnt",
                  tenentUpdatedRes.family_count
                );
                getTenentsListByResidentId();
              }
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });
        }
      } else {
        setShowLoader(true);

        if (tenentApartment == "") {
          swal("Warning", "Please Select Apartment Details", "warning", {
            timer: 3000,
            buttons: false,
          });
          // alert("Please Select Apartment");
          setShowLoader(false);
        } else {
          setShowLoader(true);

          var residentId;
          if (propsResidentId > 0) residentId = propsResidentId;
          else residentId = localStorage.getItem("residentid");

          if (tempAptCnt <= tenentOccupiedAptmtCnt) {
            var cnt = tempAptCnt + 1;

            let tenentOccupied = false;
            //This Api call checks where apartment is already assigned to tenent or not
            await makeGetRequest(
              "resident/isTenentAllocatedAptMt/" + parseInt(tenentApartment)
            )
              .then((response) => {
                if (response.data.data !== undefined) {
                  console.log(response.data.data);
                  tenentOccupied = true;
                  if (localStorage.getItem("buildingCnt") > 0) {
                    swal(
                      "Warning",
                      "Apartment Is Already Occupied By Tenant ",
                      "warning",
                      {
                        timer: 3000,
                        buttons: false,
                      }
                    );
                  } else {
                    swal(
                      "Warning",
                      "Bunglow Is Already Occupied By Tenant ",
                      "warning",
                      {
                        timer: 3000,
                        buttons: false,
                      }
                    );
                  }
                }
              })
              .catch((err) => {
                console.log(err);
                setShowLoader(false);
                swal(" " + err.response.data.message, "", "warning", {
                  timer: 2000,
                  buttons: false,
                });
              });

            if (tenentOccupied == false) {
              tenentApartmentIdList.push(parseInt(tenentApartment));
              tenentBuildLst.push(parseInt(tenentBuilding));
              tenentWingLst.push(parseInt(tenentWing));
              uniqAptLst.push(tenentAptName);
              setTempAptCnt(cnt);
              let newPass = firstname + "@" + contact_tents.slice(0, 4);
              let inputdata = {
                residenent_user_id: residentId,
                user_obj: {
                  first_name: firstname_tents,
                  last_name: lastname_tents,
                  age: tenent_age,
                  contact_no: contact_tents,
                  email_id: email_tents,
                  profile_pic: tenentProfilePic,
                  profile_mode: "public",
                },
                family_count: family_member,
                apartment_count: flat_cnt,
                apartment_id_list: tenentApartmentIdList,
                document_list: tenentDocumentsList,
                society_code: localStorage.getItem("societyCode"),
                user_type: "tenent",
                password: newPass,
                emergency_contact: false,
                schema_name: sessionStorage.getItem("schema"),
                society_id: localStorage.getItem("socityid"),
                building_ids_list: tenentBuildLst,
                wing_ids_list: tenentWingLst,
                // // apartment_id: tenentApartment,
                // apartment_id_list: tenentApartmentIdList,
                uniq_apt_name: uniqAptLst,
                occupied_date: new Date(),

                // "vehicle_owner_name":vehicle_owner_name,
                // "vehicle_reg_number":vehicle_reg_number,
                // "vehicle_number":vehicle_number
              };
              console.log(inputdata);
              await makePostRequest("resident/insert", inputdata)
                .then((response) => {
                  if (response.data.data !== undefined) {
                    setTenentDocErrorMsg("");
                    localStorage.setItem(
                      "tenentId",
                      response.data.data.resident_id
                    );
                    localStorage.setItem("isTenent", true);
                    localStorage.setItem(
                      "tenentFamilyMemCnt",
                      response.data.data.family_member
                    );
                    setTenentEditId(response.data.data.resident_id);
                    setedtentsflg(true);
                    // document.getElementById('tenentBuildingList').disabled=false;
                    // document.getElementById('tenentWingList').disabled=false;
                    // document.getElementById('tenentAptList').disabled=false;

                    setHideTenentFamVehDiv(true);
                    // viewresident();
                    swal(
                      "Tenant Added Successfully",
                      "Please Add Tenant Family Member Details",
                      "success",
                      {
                        timer: 3000,
                        buttons: false,
                      }
                    );

                    getTenentsListByResidentId();

                    setExpanded("panel03");
                    // setTenentslist(response.data.data);

                    //window.location.reload()
                  }
                  setShowLoader(false);
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                });
            }
          } else swal("No Apartments are available for Tenant");
        }
        setShowLoader(false);
      }
    }
  }

  const [vehicleTypeErrMsg, setVehicleTypeErrMsg] = React.useState("");
  //add vehicle and edit vehicle
  async function addvehicle(values, { resetForm }) {
    var residentId;
    if (vehicleType == "") {
      setVehicleTypeErrMsg("Required");
    } else {
      setVehicleTypeErrMsg("");
      if (edvehiflg == true) {
        setShowLoader(true);
        let inputdata = {
          vehicle_id: vehicleeditid,
          residenent_user_id: vehicleReseditid,
          // reg_no: registrationno,
          vehicle_no: vehicleno,
          vehicle_type: vehicleType,
          vehicle_owner_name: ownername,
          is_tenent: false,
          document_list: vehicleDocumentsList,
        };
        await makePostRequest("vehicle/update", inputdata)
          .then((response) => {
            // checked codition if responce is empty
            if (response.data.data !== undefined) {
              vehiclelisting(localStorage.getItem("residentid"));
              setownername("");
              setvehicleno("");
              setregistrationno("");
              setVehicleDocumentsList([]);
              setVehicleType("");
              setedvehiflg(false);
              setvehicleeditid("");
              swal(
                "Success",
                "Vehicle Information Updated Successfully",
                "success",
                {
                  timer: 1000,
                  buttons: false,
                }
              );
            } else {
              swal("Warning", response.data.message, "warning", {
                timer: 3000,
                buttons: false,
              });
            }
            setShowLoader(false);
            // setExpanded(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        if (propsResidentId > 0) {
          residentId = propsResidentId;
        } else {
          residentId = localStorage.getItem("residentid");
        }
        let vehicleAdded = false;
        setShowLoader(true);
        let inputdata = {
          residenent_user_id: residentId,
          // reg_no: registrationno,
          vehicle_no: vehicleno,
          vehicle_owner_name: ownername,
          vehicle_type: vehicleType,
          document_list: vehicleDocumentsList,
          is_tenent: false,
        };
        await makePostRequest("vehicle/insert", inputdata)
          .then((response) => {
            console.log("Vehicle Data " + response.data.data);
            if (response.data.data != undefined) {
              vehiclelisting(residentId);
              setownername("");
              setvehicleno("");
              setregistrationno("");
              setVehicleDocumentsList([]);

              vehicleAdded = true;
            } else {
              swal("Warning", response.data.message, "warning", {
                timer: 3000,
                buttons: false,
              });
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });

        if (vehicleAdded) {
          const optionSelected = await swal({
            title: "Vehicle Details Added Successfully",
            text: "Do you want to add Other Vehicle Details?",
            icon: "success",
            dangerMode: true,
            buttons: true,
          });
          console.log(optionSelected);
          if (optionSelected) {
            setExpanded("panel3");
            swal("Success", "Please Add Other Vehicle Details", "success", {
              timer: 3000,
              buttons: ["No", "Yes, add one more"],
            });
          } else {
            setExpanded(false);
            swal(
              "All Information of Resident Added Successfully",
              "If You Want Please Add Tenant Details",
              "success",
              {
                timer: 3000,
                buttons: false,
              }
            );
          }
        }
      }
    }
  }

  const [tenantVehicleTypeErrMsg, setTenantVehicleTypeErrMsg] =
    React.useState("");

  //add Tenent vehicle and edit vehicle
  async function addTenentVehicle(values, { resetForm }) {
    if (tenentVehicleType == "") {
      setTenantVehicleTypeErrMsg("Required");
    } else {
      setTenantVehicleTypeErrMsg("");
      if (tenentVehicleEditFlg == true) {
        setShowLoader(true);
        let inputdata = {
          vehicle_id: tenentVehicleEditId,
          residenent_user_id: tenentEditId,
          // reg_no: tenentV_RegNo,
          vehicle_no: tenentVehicleNo,
          vehicle_owner_name: tenentV_OwnerName,
          vehicle_type: tenentVehicleType,
          is_tenent: true,
          document_list: tenentVehicleDocList,
        };
        await makePostRequest("vehicle/update", inputdata)
          .then((response) => {
            // checked codition if responce is empty
            if (response.data.data !== undefined) {
              resetForm({ values: "" });
              GetTenentVehicleList(tenentEditId);
              setTenentVOwnerName("");
              setTenentVehicleNo("");
              setTenentVRegNo("");
              setTenentVehicleDocList([]);
              setTenentVehicleEditFlg(false);
              setTenentVehicleType("");
              setTenentVehDocErrorMsg("");
              setTenentVehicleEditId("");
              swal(
                "Success",
                "Vehicle Information Updated Successfully",
                "success",
                {
                  timer: 1000,
                  buttons: false,
                }
              );

              formikInitials_TenentVehicle = {
                tenentV_OwnerName: "",
                tenentV_RegNo: "",
                tenentVehicleNo: "",
              };

              // setExpanded(false);
            } else {
              swal("Warning", response.data.message, "warning", {
                timer: 3000,
                buttons: false,
              });
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        setShowLoader(true);
        let inputdata = {
          residenent_user_id: localStorage.getItem("tenentId"),
          // reg_no: tenentV_RegNo,
          vehicle_no: tenentVehicleNo,
          vehicle_owner_name: tenentV_OwnerName,
          vehicle_type: tenentVehicleType,
          is_tenent: true,
          document_list: tenentVehicleDocList,
        };
        await makePostRequest("vehicle/insert", inputdata)
          .then((response) => {
            console.log(response);
            if (response.data.data !== undefined) {
              // resetForm({ values: "" });
              GetTenentVehicleList(tenentEditId);
              setTenentVOwnerName("");
              setTenentVehicleNo("");
              setTenentVRegNo("");
              setTenentVehicleDocList([]);
              setTenentVehicleType("");
              // setExpanded(false);
              setTenentVehDocErrorMsg("");
              swal(
                "Vehicle Information Added Successfully",
                "If you want add one more vehicle",
                "success",
                {
                  timer: 3000,
                  buttons: false,
                }
              );
              formikInitials_TenentVehicle = {
                tenentV_OwnerName: "",
                tenentV_RegNo: "",
                tenentVehicleNo: "",
              };
            } else {
              swal("Warning", response.data.message, "warning", {
                timer: 3000,
                buttons: false,
              });
            }
            setShowLoader(false);
          })
          .catch(function (error) {
            // alert("In Catch");
            // console.log(response)
            setShowLoader(false);
            let msg = error.response.data.message;

            // alert(msg);
            swal("Warning", msg, "warning", {
              timer: 3000,
              buttons: false,
            });
          });
      }
    }
  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue == 1 || newValue == 3) {
      setfirstname("");
      setlastname("");
      setage("");
      setcontact("");
      setemail("");
      setrelation("");
    } else {
      viewresident();
    }
  };

  const [uniqAptName, setUniqAptName] = React.useState("");
  const [selectedBuild, setSelectedBuilding] = React.useState("");
  const [selectedWing, setSelectedWing] = React.useState("");

  const handlechangebuilding = (e) => {
    setbuildingval(e.target.value);
    setwingval("");
    setapartmentval("");
    winglisting(e.target.value);

    try {
      let idx = e.target.selectedIndex;
      let dataset = e.target.options[idx].dataset;
      // let selectedBuild = dataset.isd;
      setSelectedBuilding(dataset.isd);

      console.log("dataset",dataset.isd)

      // let tempName = selectedBuild + "/";
      // setUniqAptName(tempName);
    } catch (e) {}
  };

  const handlechangewing = (e) => {
    setwingval(e.target.value);
    setapartmentval("");
    apartmentlisting(buildingval, e.target.value);

    let idx = e.target.selectedIndex;
    let dataset = e.target.options[idx].dataset;
    // let selectedWing = dataset.isd;

    setSelectedWing(dataset.isd);
    // let tempName = uniqAptName + selectedWing + "/";
    // setUniqAptName(tempName);
  };

  async function handlechangapartment(e) {
    var str = e.target.value;
console.log(str)
    let aptName = "";
    let tempName;
    if (localStorage.getItem("buildingCnt") == 0) aptName = str;
    else {
      aptName = selectedBuild + "/" + selectedWing + "/" + e.target.value;
      tempName = uniqAptName + e.target.value;
    }

    let inputdata = {
      apartmentName: aptName,
    };
    await makePostRequest("apartment/getbyaptname", inputdata)
      .then((response) => {
        if (response.data.data.length > 0) {
          if (localStorage.getItem("buildingCnt") == 0) {
            setApartNameErrMsg("Bunglow with same name already exist.");
          } else {
            swal(
              "This apartment has already been booked !",
              "Please select other apartment....",
              "warning"
            );
          }
        } else {
          setapartmentval(str);
          // setparkingsloat(str.replace("F", "P"));

          if (localStorage.getItem("buildingCnt") == 0) setUniqAptName(str);
          else {
            setparkingsloat(str.replace("F", "P"));
            setUniqAptName(tempName);
          }

          // alert(tempName);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handlechangeresidentty = (e) => {
    // alert(e.target.value);
    setresidentty(e.target.value);
    setApartResTypeErrMsg("");
  };

  const handlechangeVehicleType = (e) => {
    setVehicleType(e.target.value);
  };

  const handlechangeTenentVehicleType = (e) => {
    setTenentVehicleType(e.target.value);
  };

  const [profile_pic, setProfilePic] = React.useState("");
  const [tenentProfilePic, setTenentProfilePic] = React.useState("");
  const [famMemberProfPic, setFamMemberProfPic] = React.useState("");
  const [tenentFamMemberProfPic, setTenentFamMemberProfPic] =
    React.useState("");

  const [documentsList, setDocumentsList] = React.useState([]);
  const [tenentDocumentsList, setTenentDocumentsList] = React.useState([]);
  const [vehicleDocumentsList, setVehicleDocumentsList] = React.useState([]);
  const [tenentVehicleDocList, setTenentVehicleDocList] = React.useState([]);
  const [Upload, setUpload] = useState(false);
  let [myArr, setMyArr] = React.useState([]);

  async function uploadImageOrFile(fileData) {
    setShowLoader(true);
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    setShowLoader(false);
    // alert("File 2" + fileUrl);
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function validateImage(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  const [profileErrMsg, setProfileErrMsg] = React.useState("");
  const [tenenProfileErrMsg, setTenentProfileErrMsg] = React.useState("");
  const [famMemProfileErrMsg, setFamMemProfileErrMsg] = React.useState("");
  const [tenenFamMemProfileErrMsg, setTenentFamMemProfileErrMsg] =
    React.useState("");

  async function uploadProfilePic(e, userType) {
    // alert(userType);
    // handle validations
    setProfileErrMsg("");
    setTenentProfileErrMsg("");
    setFamMemProfileErrMsg("");
    setTenentFamMemProfileErrMsg("");

    setShowLoader(true);
    const file = e.target.files[0];
    let validateRes = false;
    if (await validateImage(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      if (userType == "resident") setProfilePic(profilePicUrl);
      else if (userType == "tenent") setTenentProfilePic(profilePicUrl);
      else if (userType == "familyMember") setFamMemberProfPic(profilePicUrl);
      else if (userType == "tenentFamilyMember")
        setTenentFamMemberProfPic(profilePicUrl);
    } else {
      if (userType == "resident") setProfileErrMsg("Invalid file format");
      if (userType == "tenent") setTenentProfileErrMsg("Invalid file format");
      if (userType == "familyMember")
        setFamMemProfileErrMsg("Invalid file format");
      if (userType == "tenentFamilyMember")
        setTenentFamMemProfileErrMsg("Invalid file format");
    }

    setShowLoader(false);
  }

  async function uploadDocuments(e, userType) {
    // alert(userType);
    // handle validations
    setDocErrorMsg("");
    setVehDocErrorMsg("");
    setTenentDocErrorMsg("");
    setTenentVehDocErrorMsg("");

    const file = e.target.files[0];
    if (validateImageOrFile(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      if (userType == "resident") {
        documentsList.push(profilePicUrl);
        setDocumentsList(documentsList);
        // document.getElementById("documentDiv").innerHTML.reload();
      } else if (userType == "tenent") {
        // alert("In Tenent");
        tenentDocumentsList.push(profilePicUrl);
        setTenentDocumentsList(tenentDocumentsList);
      } else if (userType == "vehicle") {
        vehicleDocumentsList.push(profilePicUrl);
        setVehicleDocumentsList(vehicleDocumentsList);
      } else if (userType == "tenentVehicle") {
        tenentVehicleDocList.push(profilePicUrl);
        setTenentVehicleDocList(tenentVehicleDocList);
      }
      // setUpload(!Upload);
    } else {
      if (userType == "resident") {
        setDocErrorMsg("Invalid file format");
      } else if (userType == "tenent") {
        setTenentDocErrorMsg("Invalid file format");
      } else if (userType == "vehicle") {
        setVehDocErrorMsg("Invalid file format");
      } else if (userType == "tenentVehicle") {
        setTenentVehDocErrorMsg("Invalid file format");
      }
    }
  }

  async function deleteDocument(userType, index) {
    // alert("In delete Document " + userType);
    if (userType == "resident") {
      documentsList.splice(index, 1); // 2nd parameter means remove one item only
      setDocumentsList(documentsList);
    } else if (userType == "tenent") {
      tenentDocumentsList.splice(index, 1);
      setTenentDocumentsList(tenentDocumentsList);
    } else if (userType == "vehicle") {
      vehicleDocumentsList.splice(index, 1);
      setVehicleDocumentsList(vehicleDocumentsList);
    } else if (userType == "tenentVehicle") {
      tenentVehicleDocList.splice(index, 1);
      setTenentVehicleDocList(tenentVehicleDocList);
    }
    setUpload(!Upload);
  }

  const [tabSelected, setTabSelected] = React.useState();

  async function handleChangeTabs(tabType) {
    setTabSelected(tabType);

    if (tabType == "Tenent") {
      if (tenentOccupiedAptmtCnt == 0) {
      } else {
        setExpanded("panel02");

        if (localStorage.getItem("buildingCnt") == 0) {
          await makeGetRequest(
            "apartment/gettenentoccupied/0/0/" +
              localStorage.getItem("residentid")
          )
            .then((response) => {
              if (response.data.status === "1") {
                var data1 = response.data.data;
                setAptmtListByResident(data1);
              } else {
                setAptmtListByResident([]);
              }
            })
            .catch((err) => {
              swal("There was an error!", err, "warning");
            });
        }
      }
    } else {
      localStorage.removeItem("tenentId");
      localStorage.removeItem("isTenent");
      localStorage.removeItem("tenentFamilyMemCnt");
    }

    console.log("Resident Id ", localStorage.getItem("residentid"));
    if (
      localStorage.getItem("residentid") != null ||
      localStorage.getItem("residentid") != "null"
    ) {
      await GetTenentOccupiedAptmtLength();
    }
  }

  async function getUserByContactNo(contactNo) {
    // setFieldTouched("contact");
    setShowLoader(true);
    let inputData = {
      contact_no: contactNo,
      emailId: "",
    };
    let res = "";
    await makePostRequest("resident/verifyEmailAndContact/", inputData)
      .then((response) => {
        console.log("Contact Response ", response);

        if (response.data.status === "1") {
          if (response.data.data) {
            res = response.data.data;
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
      });
    return res;
  }

  async function getUserByEmailId(emailId) {
    // setFieldTouched("contact");
    setShowLoader(true);

    let inputData = {
      emailId: emailId,
      contact_no: "",
    };
    let res = "";
    await makePostRequest("resident/verifyEmailAndContact/", inputData)
      .then((response) => {
        console.log("Email Response ", response);
        if (response.data.status === "1") {
          if (response.data.data) {
            res = response.data.data;
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
      });
    return res;
  }

  useEffect(() => {
    // handleChange2("panel0");
    if (!expanded) setExpanded("panel0");
    localStorage.removeItem("familyMemCnt");
    localStorage.removeItem("residentName ");
    localStorage.removeItem("residentid");
    localStorage.removeItem("tenentId");
    localStorage.removeItem("isTenent");

    if (propsResidentId > 0) {
      viewresident();
    } else if (tabSelected == "Owners") {
      // document.getElementById("residentSubBtn").disabled = true;
    }

    buildinglist();
  }, [Upload]);

  // For Modal
  const [open2, setOpen2] = React.useState(false);
  const [scroll2, setScroll2] = React.useState("paper");

  const handleClickOpen2 = (scrollType) => () => {
    setOpen2(true);
    setScroll2(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  const [newPassword, setNewPassword] = React.useState("");
  const [oldPassword, setOldPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [errorMsg, setErrorMessage] = React.useState("");
  const [confirmErrorMsg, setConfirmErrorMessage] = React.useState("");
  const [successMsg, setSuccessMessage] = React.useState("");

  async function handleChangeConfirmPassword(newValue) {
    if (newPassword != newValue) {
      // setSuccessMessage("");
      setConfirmErrorMessage("Password Not Matched");
      setConfirmPassword(newValue);
    } else {
      // setSuccessMessage("Password Verified");
      setConfirmErrorMessage("");
      setConfirmPassword(newValue);
      document.getElementById("submitPassword").disabled = false;
    }
  }

  async function validatePassword(password) {
    var lowerCase = /[a-z]/g;
    var upperCase = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var specialChar = /[!@#\$%\^\&\b*\)\(+=._-]/g;

    if (!password.match(lowerCase)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(upperCase)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(numbers)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(specialChar)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (password.length < 8) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else {
      setErrorMessage("");
      setNewPassword(password);
      document.getElementById("confirmPassword").disabled = false;
    }
  }

  async function changePassword() {
    if (password != "" && confirmPassword != "" && oldPassword != "") {
      var inputdata = {
        resident_id: localStorage.getItem("residentid"),
        password: oldPassword,
        newpassword: newPassword,
      };
      makePostRequest("resident/changePassword", inputdata)
        .then(async (response) => {
          console.log(response);
          if (response.data.data !== undefined) {
            console.log(response);
            swal("Success", "Password Changed Successfully..", {
              timer: 1000,
              buttons: false,
            });
            navigate("/");
          }
        })
        .catch((err) => {
          swal(" " + err.response.status, "Invalid Data", "warning", {
            timer: 2000,
            buttons: true,
          });
        });
    } else {
      swal("Invalid Data !!", "Please Fill All Values", "warning");
    }
  }

  async function handleSelectRadio(e, apartment_id) {
    console.log(e);
    // alert(e.target.value);
    // alert(apartment_id);

    setFamMemAptmtNo(e.target.value);
    setFamAPtmtId(apartment_id);
  }

  async function showPassword(passwordTypeId) {
    // if (passwordType) {
    //   var confirmPasswordEle = document.getElementById("confirmPassword");
    //   if (confirmPasswordEle.type === "password") {
    //     confirmPasswordEle.type = "text";
    //   } else {
    //     confirmPasswordEle.type = "password";
    //   }
    // } else {
    var passwordEle = document.getElementById(passwordTypeId);
    if (passwordEle.type === "password") {
      passwordEle.type = "text";
    } else {
      passwordEle.type = "password";
    }
    // }
  }

  async function handleChangeRadioGroup(e) {
    if (e.target.value == "Yes") setIsEmergencyContact(true);
    else setIsEmergencyContact(false);
  }

  return (
    <>
      <div className="addResiTabStMain">
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label="Owner Details"
                {...a11yProps(0)}
                onClick={() => handleChangeTabs("Owners")}
              />
              <Tab
                label="Tenant Details"
                {...a11yProps(1)}
                onClick={() => handleChangeTabs("Tenent")}
              />
            </Tabs>
          </Box>
          {/* //Resident Section */}
          <TabPanel
            value={value}
            index={0}
            className="tabPanelTopSpace tabPanelTopSpace2"
          >
            <Formik
              enableReinitialize
              initialValues={formikInitials}
              validationSchema={Validation_Schema}
              onSubmit={addrecidency}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                touched,
                isValid,
                handleSubmit,
              }) => (
                <Form>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} md={12}>
                          <div
                            className="acordingViewMain acordingViewMain2"
                            style={{ padding: 0 }}
                          >
                            <Accordion
                              // defaultExpanded={true}
                              expanded={expanded === "panel0"}
                              onChange={handleChange2("panel0")}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                              >
                                {localStorage.getItem("buildingCnt") > 0 ? (
                                  <>
                                    {propsResidentId ? (
                                      <Typography>
                                        Update Apartment Owner
                                      </Typography>
                                    ) : (
                                      <Typography>
                                        Add Apartment Owner
                                      </Typography>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {propsResidentId ? (
                                      <Typography>
                                        Update Bunglow Owner
                                      </Typography>
                                    ) : (
                                      <Typography>Add Bunglow Owner</Typography>
                                    )}
                                  </>
                                )}
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="acordingCont">
                                  <Grid
                                    container
                                    spacing={3}
                                    style={{ marginTop: "10px" }}
                                  >
                                    <Grid item xs={12} md={6}>
                                      <div className="tabLeftDiv">
                                        <div className="uploadImDiv">
                                          <div className="uploadIm">
                                            {profile_pic ? (
                                              <img src={profile_pic} />
                                            ) : (
                                              <img src={defaultProfilePic} />
                                            )}
                                          </div>
                                          <div className="uploadInpu">
                                            <FileUploadIcon />
                                            <span>Upload Profile Photo</span>
                                            <em className="uploadPhotoErrorMsg">
                                              {profileErrMsg}
                                            </em>
                                            <input
                                              type="file"
                                              id="profile_pic"
                                              value={values.profile_pic}
                                              onChange={(event) =>
                                                uploadProfilePic(
                                                  event,
                                                  "resident"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <Grid container spacing={3}>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              First Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="First Name"
                                              value={values.firstname}
                                              onChange={handleChange(
                                                "firstname"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("firstname")
                                              }
                                              onChangeCapture={(e) =>
                                                setfirstname(e.target.value)
                                              }
                                            />
                                            {errors.firstname &&
                                            touched.firstname ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.firstname}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Last Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Last Name"
                                              value={values.lastname}
                                              onChange={handleChange(
                                                "lastname"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("lastname")
                                              }
                                              onChangeCapture={(e) =>
                                                setlastname(e.target.value)
                                              }
                                            />
                                            {errors.lastname &&
                                            touched.lastname ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.lastname}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Phone Number{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Phone Number"
                                              id="contact"
                                              maxLength={10}
                                              value={values.contact}
                                              onChange={handleChange("contact")}
                                              onBlur={(e) =>
                                                setFieldTouched("contact")
                                              }
                                              // onBlur={(e) =>
                                              //   getUserByContactNo(e.target.value, "Resident")
                                              // }
                                              onChangeCapture={(e) =>
                                                setcontact(e.target.value)
                                              }
                                            />
                                            {errors.contact &&
                                            touched.contact ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.contact}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Email Id{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Email Id"
                                              id="email"
                                              value={values.email}
                                              onChange={handleChange("email")}
                                              onBlur={(e) =>
                                                setFieldTouched("email")
                                              }
                                              // onBlur={(e) =>
                                              //   getUserByEmailId(e.target.value, "Resident")
                                              // }
                                              onChangeCapture={(e) =>
                                                setemail(e.target.value)
                                              }
                                            />
                                            {errors.email && touched.email ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.email}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Age{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Age"
                                              maxLength={2}
                                              value={values.age}
                                              onChange={handleChange("age")}
                                              onBlur={() =>
                                                setFieldTouched("age")
                                              }
                                              onChangeCapture={(e) =>
                                                setage(e.target.value)
                                              }
                                            />
                                            {errors.age && touched.age ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.age}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Family Members Count{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              maxLength={2}
                                              placeholder="Family Members Count"
                                              value={values.family_mem_cnt}
                                              onChange={handleChange(
                                                "family_mem_cnt"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched(
                                                  "family_mem_cnt"
                                                )
                                              }
                                              onChangeCapture={(e) =>
                                                setfamily_mem_cnt(
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {errors.family_mem_cnt &&
                                            touched.family_mem_cnt ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.family_mem_cnt}
                                              </div>
                                            ) : (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {famMemErrMsg}
                                              </div>
                                            )}
                                          </Grid>

                                          <Grid item xs={12} md={12}>
                                            <label className="tabsLabel">
                                              {localStorage.getItem(
                                                "buildingCnt"
                                              ) == 0 ? (
                                                <span>Bungalow's Owned?</span>
                                              ) : (
                                                <span>Apartments Owned?</span>
                                              )}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            {localStorage.getItem(
                                              "buildingCnt"
                                            ) == 0 ? (
                                              <input
                                                className="inputSt"
                                                value={values.flat_cnt}
                                                maxLength={2}
                                                placeholder="Bungalow's Owned?"
                                                onChange={handleChange(
                                                  "flat_cnt"
                                                )}
                                                onBlur={() =>
                                                  setFieldTouched("flat_cnt")
                                                }
                                                onChangeCapture={(e) =>
                                                  setflat_cnt(e.target.value)
                                                }
                                              />
                                            ) : (
                                              <input
                                                className="inputSt"
                                                value={values.flat_cnt}
                                                maxLength={2}
                                                placeholder="Apartments Owned?"
                                                onChange={handleChange(
                                                  "flat_cnt"
                                                )}
                                                onBlur={() =>
                                                  setFieldTouched("flat_cnt")
                                                }
                                                onChangeCapture={(e) =>
                                                  setflat_cnt(e.target.value)
                                                }
                                              />
                                            )}

                                            {errors.flat_cnt &&
                                            touched.flat_cnt ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.flat_cnt}
                                              </div>
                                            ) : (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {aptCntErrMsg}
                                              </div>
                                            )}
                                          </Grid>
                                          <Grid item xs={12} md={12}>
                                            <label className="tabsLabel">
                                              Do you want to add this resident
                                              in a emergency contact list?
                                            </label>
                                            <div className="myBtMain">
                                              <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                              >
                                                <FormControlLabel
                                                  value="Yes"
                                                  control={<Radio />}
                                                  label="Yes"
                                                  checked={
                                                    isEmergencyContact === true
                                                  }
                                                  onChange={(e) =>
                                                    handleChangeRadioGroup(e)
                                                  }
                                                />
                                                <FormControlLabel
                                                  value="No"
                                                  control={<Radio />}
                                                  label="No"
                                                  checked={
                                                    isEmergencyContact === false
                                                  }
                                                  onChange={(e) =>
                                                    handleChangeRadioGroup(e)
                                                  }
                                                />
                                              </RadioGroup>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <div className="tabViewOfProviderRight">
                                        <h4 className="doquProviderHed">
                                          Documents
                                        </h4>
                                        <div className="societyDoc">
                                          <h4 className="documeUpload documeUploadIcon">
                                            Upload Documents
                                            <Button className="forUploadOnly">
                                              <FileUploadIcon />
                                              <input
                                                type="file"
                                                style={{
                                                  opacity: 0,
                                                  position: "absolute",
                                                  left: 0,
                                                }}
                                                id="documentsList"
                                                value={values.documentsList}
                                                onChange={(event) =>
                                                  uploadDocuments(
                                                    event,
                                                    "resident"
                                                  )
                                                }
                                                onChangeCapture={() =>
                                                  setDocumentsList(
                                                    documentsList
                                                  )
                                                }
                                              />
                                            </Button>
                                          </h4>
                                        </div>
                                        {docErrorMsg ? (
                                          <div className="errorField errorFieldFForLogin forInvalidFile">
                                            {docErrorMsg}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        {documentsList ? (
                                          <>
                                            <div className="docScrollBar">
                                              {documentsList.map(
                                                (option, index) => (
                                                  <div
                                                    id="documentDiv"
                                                    className="doqumentDiv1"
                                                  >
                                                    <Zoom>
                                                      <div className="doquView">
                                                        {option
                                                          .split(".")
                                                          .pop() == "txt" ? (
                                                          <img src={txtImage} />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "pdf" ? (
                                                          <img src={pdfImage} />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "docx" ||
                                                          option
                                                            .split(".")
                                                            .pop() == "doc" ? (
                                                          <img
                                                            src={wordImage}
                                                          />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "xls" ||
                                                          option
                                                            .split(".")
                                                            .pop() == "xlsx" ? (
                                                          <img
                                                            src={excelImage}
                                                          />
                                                        ) : (
                                                          <img src={option} />
                                                        )}
                                                      </div>
                                                    </Zoom>
                                                    <span>
                                                      <a href={option}>
                                                        {option
                                                          .split("/")
                                                          .pop()
                                                          .replace("%20", " ")}
                                                      </a>
                                                      <DoneIcon className="doneIcon" />{" "}
                                                    </span>

                                                    <Button
                                                      className="documRemove"
                                                      onClick={() =>
                                                        deleteDocument(
                                                          "resident",
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <DeleteForeverIcon className="deleIco" />
                                                    </Button>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          <span>No Documents Uploaded yet</span>
                                        )}
                                      </div>
                                    </Grid>
                                    {/* {propsResidentId ? (
                                      <Grid
                                        item
                                        xs={12}
                                        md={12}
                                        style={{ textAlign: "center" }}
                                      >
                                        <h1
                                          className="changePassAnchr"
                                          onClick={handleClickOpen2("body")}
                                        >
                                          Change Password
                                        </h1>
                                      </Grid>
                                    ) : (
                                      <></>
                                    )} */}
                                    <Grid item xs={12} md={12}>
                                      <div
                                        className="addOwnerTopLine cancelBtForAllOuter"
                                        style={{ textAlign: "center" }}
                                      >
                                        {propsResidentId > 0 ? (
                                          <Button className="addBt cancelBtForAll">
                                            Cancel
                                          </Button>
                                        ) : (
                                          <></>
                                        )}
                                        <Button
                                          className="addBt"
                                          type="submit"
                                          id="residentSubBtn"
                                        >
                                          {localStorage.getItem(
                                            "buildingCnt"
                                          ) == 0 ? (
                                            <>
                                              {propsResidentId > 0 ? (
                                                <div> Edit Bungalow Owner </div>
                                              ) : (
                                                <div> Add Bungalow Owner</div>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {propsResidentId > 0 ? (
                                                <div>
                                                  {" "}
                                                  Edit Apartment Owner{" "}
                                                </div>
                                              ) : (
                                                <div> Add Apartment Owner</div>
                                              )}
                                            </>
                                          )}
                                        </Button>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Grid for Building adding */}
                    {localStorage.getItem("buildingCnt") == 0 ? (
                      <Grid item xs={12} md={12}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12}>
                            <div
                              className="acordingViewMain acordingViewMain2"
                              style={{ padding: 0 }}
                            >
                              <Accordion
                                expanded={expanded === "panel1"}
                                onChange={handleChange2("panel1")}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel2bh-content"
                                  id="panel2bh-header"
                                >
                                  {edapartflg ? (
                                    <Typography>Update Bungalow</Typography>
                                  ) : (
                                    <Typography>Assign Bungalow</Typography>
                                  )}
                                </AccordionSummary>

                                {showAptmtAccordian ? (
                                  <AccordionDetails>
                                    <div className="acordingCont">
                                      <Grid
                                        container
                                        spacing={3}
                                        style={{ marginTop: "10px" }}
                                      >
                                        <Grid item xs={12} md={4}>
                                          {apartmentlist.length > 0 ? (
                                            <>
                                              {apartmentlist.map(
                                                (option, index) => (
                                                  <div
                                                    className="tenentLeftContentMain"
                                                    key={index}
                                                  >
                                                    <ul>
                                                      <li
                                                        className={
                                                          option.apartment_id ==
                                                          aparteditid
                                                            ? "addedApartCont selectedTailSt"
                                                            : "addedApartCont"
                                                        }
                                                      >
                                                        <div className="editAndRelocatIconDiv">
                                                          {option.occupancy_type !=
                                                          "Vacant" ? (
                                                            <CreateIcon
                                                              className="creatIcoForAdEdi"
                                                              onClick={() =>
                                                                editapartment(
                                                                  option.apartment_id,
                                                                  option.is_resident,
                                                                  option.uniq_apt_name
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <></>
                                                          )}
                                                          {option.occupancy_type ==
                                                          "Vacant" ? (
                                                            <Tooltip
                                                              title="Re-location"
                                                              placement="top"
                                                              arrow
                                                            >
                                                              <AddHomeIcon
                                                                className="rellocationIco"
                                                                onClick={() =>
                                                                  editapartment(
                                                                    option.apartment_id,
                                                                    option.is_resident,
                                                                    option.uniq_apt_name
                                                                  )
                                                                }
                                                              />
                                                              {/* <img src={reLocatIcon} className="delIc rellocationIco"/> */}
                                                            </Tooltip>
                                                          ) : (
                                                            <></>
                                                          )}
                                                        </div>
                                                        <h4>
                                                          <p>
                                                            {" "}
                                                            {
                                                              option.occupancy_type
                                                            }
                                                          </p>
                                                        </h4>
                                                        <span>
                                                          {" "}
                                                          {option.uniq_apt_name}
                                                        </span>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                )
                                              )}
                                            </>
                                          ) : (
                                            <div className="recordNotFound">
                                              <img src={reecordNotFound} />
                                            </div>
                                          )}
                                        </Grid>

                                        <Grid item xs={12} md={8}>
                                          <div className="newAddResiMain">
                                            <div className="tabLeftDiv">
                                              <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Bungalow Name/No
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="inputSt"
                                                    placeholder="Enter Bungalow Name"
                                                    value={apartmentval}
                                                    onChangeCapture={(e) =>
                                                      setapartmentval(
                                                        e.target.value
                                                      )
                                                    }
                                                    onBlur={
                                                      handlechangapartment
                                                    }
                                                  />
                                                  <p className="errorField">
                                                    {apartNameErrMsg}
                                                  </p>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Assigned Parking Slot
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="inputSt"
                                                    placeholder="Assigned Parking Slot"
                                                    value={parkingsloat}
                                                    onChangeCapture={(e) =>
                                                      setparkingsloat(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  <p className="errorField">
                                                    {apartParkingSlotErrMsg}
                                                  </p>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Resident Type
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select
                                                    id="residentTypeList"
                                                    className="inputSt"
                                                    value={residentty}
                                                    onChange={
                                                      handlechangeresidentty
                                                    }
                                                  >
                                                    <option value="">
                                                      Resident Type
                                                    </option>
                                                    <option value="Owner Occupied">
                                                      Owner Occupied
                                                    </option>
                                                    <option value="Tenant Occupied">
                                                      Tenant Occupied
                                                    </option>
                                                    <option value="Vacant">
                                                      Vacant
                                                    </option>
                                                  </select>
                                                  <p className="errorField">
                                                    {apartResTypeErrMsg}
                                                  </p>
                                                </Grid>
                                                {residentty ==
                                                "Owner Occupied" ? (
                                                  <Grid item xs={12} md={6}>
                                                    <label className="tabsLabel">
                                                      Owner current Stay
                                                    </label>
                                                    <div className="myBtMain mainRadioSt">
                                                      <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        defaultValue="female"
                                                        name="radio-buttons-group"
                                                      >
                                                        <FormControlLabel
                                                          value="true"
                                                          control={<Radio />}
                                                          label="Yes"
                                                          checked={
                                                            isCurrentStay ===
                                                            true
                                                          }
                                                          onChange={(e) =>
                                                            setIsCurrentStay(
                                                              true
                                                            )
                                                          }
                                                        />
                                                        <FormControlLabel
                                                          value="false"
                                                          control={<Radio />}
                                                          label="No"
                                                          checked={
                                                            isCurrentStay ===
                                                            false
                                                          }
                                                          onChange={(e) =>
                                                            setIsCurrentStay(
                                                              false
                                                            )
                                                          }
                                                        />
                                                      </RadioGroup>
                                                    </div>
                                                  </Grid>
                                                ) : (
                                                  <></>
                                                )}
                                                <Grid item xs={12} md={12}>
                                                  <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                      {edapartflg == true ? (
                                                        <Button
                                                          className="addBt cancelBtForAll forFullWidthCancelBt"
                                                          onClick={
                                                            handleCancelAptmt
                                                          }
                                                        >
                                                          Cancel
                                                        </Button>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </Grid>
                                                    {apartmentlist.length <
                                                      flat_cnt &&
                                                    edapartflg == false ? (
                                                      <Grid item xs={12} md={6}>
                                                        <Button
                                                          className="addApBt"
                                                          onClick={() =>
                                                            addBunglow()
                                                          }
                                                        >
                                                          <div>
                                                            Allocate Bungalow
                                                          </div>
                                                        </Button>
                                                      </Grid>
                                                    ) : (
                                                      <>
                                                        {apartmentlist.length <=
                                                          flat_cnt &&
                                                        edapartflg ? (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                          >
                                                            <Button
                                                              className="addApBt"
                                                              onClick={() =>
                                                                addBunglow()
                                                              }
                                                            >
                                                              <div>
                                                                Update Bungalow
                                                              </div>
                                                            </Button>
                                                          </Grid>
                                                        ) : (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={12}
                                                          >
                                                            <p className="wingErrorTx">
                                                              All bungalows
                                                              allocated
                                                              successfully if
                                                              you want to
                                                              allocate more
                                                              bungalow please
                                                              update bungalow
                                                              count.
                                                            </p>
                                                          </Grid>
                                                        )}
                                                      </>
                                                    )}
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  </AccordionDetails>
                                ) : (
                                  <AccordionDetails>
                                    <span className="warningTxt">
                                      <b className="blink_me">
                                        Please Add Resident First
                                      </b>
                                    </span>
                                  </AccordionDetails>
                                )}
                              </Accordion>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid item xs={12} md={12}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12} style={{ paddingTop: 0 }}>
                            <div
                              className="acordingViewMain acordingViewMain2"
                              style={{ padding: 0 }}
                            >
                              <Accordion
                                expanded={expanded === "panel1"}
                                onChange={handleChange2("panel1")}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel2bh-content"
                                  id="panel2bh-header"
                                >
                                  {edapartflg ? (
                                    <Typography>Update Apartment</Typography>
                                  ) : (
                                    <Typography>Assign Apartment</Typography>
                                  )}
                                </AccordionSummary>
                                {showAptmtAccordian ? (
                                  <AccordionDetails>
                                    <div className="acordingCont">
                                      <Grid
                                        container
                                        spacing={3}
                                        style={{ marginTop: "10px" }}
                                      >
                                        <Grid item xs={12} md={4}>
                                          {apartmentlist.length > 0 ? (
                                            <>
                                              {apartmentlist.map(
                                                (option, index) => (
                                                  <div
                                                    className="tenentLeftContentMain"
                                                    key={index}
                                                  >
                                                    <ul>
                                                      <li
                                                        className={
                                                          option.apartment_id ==
                                                          aparteditid
                                                            ? "addedApartCont selectedTailSt"
                                                            : "addedApartCont"
                                                        }
                                                      >
                                                        <div className="editAndRelocatIconDiv">
                                                          {option.occupancy_type !=
                                                          "Vacant" ? (
                                                            <CreateIcon
                                                              className="creatIcoForAdEdi"
                                                              onClick={() =>
                                                                editapartment(
                                                                  option.apartment_id,
                                                                  option.is_resident,
                                                                  option.uniq_apt_name
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <></>
                                                          )}

                                                          {option.occupancy_type ==
                                                          "Vacant" ? (
                                                            <Tooltip
                                                              title="Reallocate"
                                                              placement="top"
                                                              arrow
                                                            >
                                                              <AddHomeIcon
                                                                className="rellocationIco"
                                                                onClick={() =>
                                                                  editapartment(
                                                                    option.apartment_id,
                                                                    option.is_resident,
                                                                    option.uniq_apt_name
                                                                  )
                                                                }
                                                              />
                                                              {/* <img src={reLocatIcon} className="delIc rellocationIco"/> */}
                                                            </Tooltip>
                                                          ) : (
                                                            <></>
                                                          )}
                                                        </div>
                                                        <h4>
                                                          <p>
                                                            {" "}
                                                            {
                                                              option.occupancy_type
                                                            }
                                                          </p>
                                                        </h4>
                                                        <span>
                                                          {" "}
                                                          {option.uniq_apt_name}
                                                        </span>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                )
                                              )}
                                            </>
                                          ) : (
                                            <div className="recordNotFound">
                                              <img src={reecordNotFound} />
                                            </div>
                                          )}
                                        </Grid>

                                        <Grid item xs={12} md={8}>
                                          <div className="newAddResiMain">
                                            <div className="tabLeftDiv">
                                              <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Select Building{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select id="buildingId"
                                                    className="inputSt"
                                                    value={buildingval}
                                                    // onChange={event => handlechangebuilding(event,option.building_name )}
                                                    onChange={
                                                      handlechangebuilding
                                                    }
                                                  >
                                                    <option value="" disabled>
                                                      Select Building
                                                    </option>
                                                    {allbuilding.map(
                                                      (option) => (
                                                        <option
                                                          key={
                                                            option.building_id
                                                          }
                                                          value={
                                                            option.building_id
                                                          }
                                                          data-isd={
                                                            option.building_name
                                                          }
                                                        >
                                                          {option.building_name}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                  <p className="errorField">
                                                    {apartBuilErrMsg}
                                                  </p>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Select Wing{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select id="wingId"
                                                    className="inputSt"
                                                    value={wingval}
                                                    onChange={handlechangewing}
                                                  >
                                                    <option value="" disabled>
                                                      Select Wing
                                                    </option>
                                                    {allwing.map((option) => (
                                                      <option
                                                        key={option.wing_id}
                                                        value={option.wing_id}
                                                        data-isd={
                                                          option.wing_name
                                                        }
                                                      >
                                                        {option.wing_name}
                                                      </option>
                                                    ))}
                                                  </select>
                                                  <p className="errorField">
                                                    {apartWingErrMsg}
                                                  </p>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Select Apartment{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select id="apartmentId"
                                                    className="inputSt"
                                                    value={apartmentval}
                                                    onChange={
                                                      handlechangapartment
                                                    }
                                                  >
                                                    <option value="" disabled>
                                                      Select Apartment
                                                    </option>
                                                    {allapartment.map(
                                                      (option) => (
                                                        <option
                                                          key={option}
                                                          value={option}
                                                          data-isd={option}
                                                        >
                                                          {option}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                  <p className="errorField">
                                                    {apartNameErrMsg}
                                                  </p>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Assigned Parking Slot{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="inputSt"
                                                    placeholder="Assigned Parking Slot"
                                                    value={parkingsloat}
                                                    onChangeCapture={(e) =>
                                                      setparkingsloat(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  <p className="errorField">
                                                    {apartParkingSlotErrMsg}
                                                  </p>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Resident Type{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select
                                                    id="residentTypeList"
                                                    className="inputSt"
                                                    value={residentty}
                                                    onChange={
                                                      handlechangeresidentty
                                                    }
                                                  >
                                                    <option value="">
                                                      Resident Type
                                                    </option>
                                                    <option value="Owner Occupied">
                                                      Owner Occupied
                                                    </option>
                                                    <option value="Tenant Occupied">
                                                      Tenant Occupied
                                                    </option>
                                                    <option value="Vacant">
                                                      Vacant
                                                    </option>
                                                  </select>
                                                  <p className="errorField">
                                                    {apartResTypeErrMsg}
                                                  </p>
                                                </Grid>
                                                {residentty ==
                                                "Owner Occupied" ? (
                                                  <Grid item xs={12} md={6}>
                                                    <label className="tabsLabel">
                                                      Owner current Stay
                                                    </label>
                                                    <div className="myBtMain mainRadioSt">
                                                      <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        defaultValue="female"
                                                        name="radio-buttons-group"
                                                      >
                                                        <FormControlLabel
                                                          value="true"
                                                          control={<Radio />}
                                                          label="Yes"
                                                          checked={
                                                            isCurrentStay ===
                                                            true
                                                          }
                                                          onChange={(e) =>
                                                            setIsCurrentStay(
                                                              true
                                                            )
                                                          }
                                                        />
                                                        <FormControlLabel
                                                          value="false"
                                                          control={<Radio />}
                                                          label="No"
                                                          checked={
                                                            isCurrentStay ===
                                                            false
                                                          }
                                                          onChange={(e) =>
                                                            setIsCurrentStay(
                                                              false
                                                            )
                                                          }
                                                        />
                                                      </RadioGroup>
                                                    </div>
                                                  </Grid>
                                                ) : (
                                                  <></>
                                                )}
                                                <Grid item xs={12} md={12}>
                                                  <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                      {edapartflg == true ? (
                                                        <Button
                                                          className="addBt cancelBtForAll forFullWidthCancelBt"
                                                          onClick={
                                                            handleCancelAptmt
                                                          }
                                                        >
                                                          Cancel
                                                        </Button>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </Grid>

                                                    {apartmentlist.length <
                                                      flat_cnt &&
                                                    edapartflg == false ? (
                                                      <Grid item xs={12} md={6}>
                                                        <Button
                                                          className="addApBt"
                                                          onClick={() =>
                                                            addappartment()
                                                          }
                                                        >
                                                          <div>
                                                            Allocate Apartment
                                                          </div>
                                                        </Button>
                                                      </Grid>
                                                    ) : (
                                                      <>
                                                        {apartmentlist.length <=
                                                          flat_cnt &&
                                                        edapartflg ? (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                          >
                                                            <Button
                                                              className="addApBt"
                                                              onClick={() =>
                                                                addappartment()
                                                              }
                                                            >
                                                              <div>
                                                                Update Apartment
                                                              </div>
                                                            </Button>
                                                          </Grid>
                                                        ) : (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={12}
                                                          >
                                                            <p className="wingErrorTx">
                                                              All apartments
                                                              allocated
                                                              successfully if
                                                              you want to
                                                              allocate more
                                                              apartments please
                                                              update apartment
                                                              count.
                                                            </p>
                                                          </Grid>
                                                        )}
                                                      </>
                                                    )}
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  </AccordionDetails>
                                ) : (
                                  <AccordionDetails>
                                    <span className="warningTxt">
                                      <b className="blink_me">
                                        Please Add Resident First
                                      </b>
                                    </span>
                                  </AccordionDetails>
                                )}
                              </Accordion>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Form>
              )}
            </Formik>

            <Grid container spacing={3}>
              {/* kkk */}
              {/* {(props.name < 0 || props.name==undefined) && */}

              {/* Grid for Accordian of Family Member and Vehicle */}

              {showFamVehAccordian ? (
                <Grid item xs={12} md={12}>
                  <div className="acordingViewMain" style={{ padding: 0 }}>
                    <Accordion
                      expanded={expanded === "panel2"}
                      onChange={handleChange2("panel2")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                      >
                        {edfamilyflg ? (
                          <Typography>Update Family Members</Typography>
                        ) : (
                          <Typography>Add Family Members</Typography>
                        )}
                      </AccordionSummary>

                      <AccordionDetails>
                        <div className="acordingCont">
                          <Grid
                            container
                            spacing={3}
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} md={4}>
                              {famlisting.length > 0 ? (
                                <div className="tenentLeftContentMain showRadioDetailsLine">
                                  <ul>
                                    {famlisting.map((option) => (
                                      <li
                                        className={
                                          option.member_id == familyeditid
                                            ? "selectedTailSt"
                                            : ""
                                        }
                                      >
                                        <div className="manageIcons">
                                          <CreateIcon
                                            className="delIc creatIcoForAdEdi"
                                            onClick={() =>
                                              editfamilymember(option.member_id)
                                            }
                                          />
                                          <DeleteIcon
                                            className="delIc"
                                            onClick={() =>
                                              deletefamilymember(
                                                option.member_id
                                              )
                                            }
                                          />
                                        </div>
                                        <div className="tenantDProfile">
                                          <Zoom>
                                            {option.user_obj.profile_pic ? (
                                              <img
                                                src={
                                                  option.user_obj.profile_pic
                                                }
                                              />
                                            ) : (
                                              <img src={defaultProfilePic} />
                                            )}
                                          </Zoom>
                                        </div>
                                        <h4>
                                          {option.user_obj.first_name}{" "}
                                          {option.user_obj.last_name}
                                          {/* <span>({option.relation})</span> */}
                                          {/* <b className="ageSt">
                                          {option.user_obj.age} Years
                                        </b> */}
                                        </h4>
                                        <div className=" ">
                                          <span>({option.relation})</span>
                                          <b className="ageSt">
                                            {option.user_obj.age} Years
                                          </b>
                                        </div>

                                        <div className="uploadDetailsOut">
                                          <span className="mobNum">
                                            <CallIcon className="forEmailAndPhone" />
                                            {option.user_obj.contact_no}
                                          </span>
                                          <span>
                                            <MarkunreadIcon className="forEmailAndPhone" />
                                            {option.user_obj.email_id}
                                          </span>
                                          <span>
                                            <MeetingRoomIcon className="forEmailAndPhone" />
                                            {option.apartment_no}
                                          </span>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              ) : (
                                <div className="recordNotFound">
                                  <img src={reecordNotFound} />
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={12} md={8}>
                              <Formik
                                enableReinitialize
                                initialValues={formikInitials_family}
                                validationSchema={Validation_Schema_family}
                                onSubmit={addfamilymem}
                              >
                                {({
                                  values,
                                  handleChange,
                                  errors,
                                  setFieldTouched,
                                  touched,
                                  isValid,
                                  handleSubmit,
                                }) => (
                                  <Form>
                                    <div className="newAddResiMain">
                                      <div className="tabLeftDiv">
                                        <div className="uploadImDiv">
                                          <div className="uploadIm">
                                            {famMemberProfPic ? (
                                              <img src={famMemberProfPic} />
                                            ) : (
                                              <img src={defaultProfilePic} />
                                            )}
                                          </div>
                                          <div className="uploadInpu">
                                            <FileUploadIcon />
                                            <span>Upload Profile Photo</span>
                                            <em className="uploadPhotoErrorMsg">
                                              {famMemProfileErrMsg}
                                            </em>
                                            <input
                                              type="file"
                                              id="famMemberProfPic"
                                              value={values.famMemberProfPic}
                                              onChange={(event) =>
                                                uploadProfilePic(
                                                  event,
                                                  "familyMember"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        <Grid container spacing={3}>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              First Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="First Name"
                                              value={values.fam_firstname}
                                              onChange={handleChange(
                                                "fam_firstname"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("fam_firstname")
                                              }
                                              onChangeCapture={(e) =>
                                                setfam_firstname(e.target.value)
                                              }
                                            />
                                            {errors.fam_firstname &&
                                            touched.fam_firstname ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.fam_firstname}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Last Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Last Name"
                                              value={values.fam_lastname}
                                              onChange={handleChange(
                                                "fam_lastname"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("fam_lastname")
                                              }
                                              onChangeCapture={(e) =>
                                                setfam_lastname(e.target.value)
                                              }
                                            />
                                            {errors.fam_lastname &&
                                            touched.fam_lastname ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.fam_lastname}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Phone Number (Default Owners Phone
                                              No){" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Phone Number"
                                              maxLength={10}
                                              value={values.fam_contact}
                                              onChange={handleChange(
                                                "fam_contact"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("fam_contact")
                                              }
                                              onChangeCapture={(e) =>
                                                setfam_contact(e.target.value)
                                              }
                                            />
                                            {errors.fam_contact &&
                                            touched.fam_contact ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.fam_contact}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Relation{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <select
                                              className="inputSt"
                                              value={relation}
                                              onChange={(e) =>
                                                setrelation(e.target.value)
                                              }
                                            >
                                              <option value="">Select</option>
                                              <option value="Father">
                                                Father
                                              </option>
                                              <option value="Mother">
                                                Mother
                                              </option>
                                              <option value="Son">Son</option>
                                              <option value="Daughter">
                                                Daughter
                                              </option>
                                              <option value="Husband">
                                                Husband
                                              </option>
                                              <option value="Wife">Wife</option>
                                              <option value="Brother">
                                                Brother
                                              </option>
                                              <option value="Sister">
                                                Sister
                                              </option>
                                              <option value="Grandfather">
                                                Grandfather
                                              </option>
                                              <option value="Grandmother">
                                                Grandmother
                                              </option>
                                              <option value="Grandson">
                                                Grandson
                                              </option>
                                              <option value="Uncle">
                                                Uncle
                                              </option>
                                              <option value="Aunt">Aunt</option>
                                              <option value="Nephew">
                                                Nephew
                                              </option>
                                              <option value="Niece">
                                                Niece
                                              </option>
                                              <option value="Cousin">
                                                Cousin
                                              </option>

                                              {/* <option>Other</option> */}
                                            </select>
                                            {/* <input
                                            className="inputSt"
                                            placeholder="Relation"
                                            value={values.relation}
                                            onChange={handleChange("relation")}
                                            onBlur={() =>
                                              setFieldTouched("relation")
                                            }
                                            onChangeCapture={(e) =>
                                              setrelation(e.target.value)
                                            }
                                          /> */}
                                            {errors.relation &&
                                            touched.relation ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.relation}
                                              </div>
                                            ) : null}
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Email Id (Default Owners Email Id){" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Email Id"
                                              value={values.fam_email}
                                              onChange={handleChange(
                                                "fam_email"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("fam_email")
                                              }
                                              onChangeCapture={(e) =>
                                                setfam_email(e.target.value)
                                              }
                                            />
                                            {errors.fam_email &&
                                            touched.fam_email ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.fam_email}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Age{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Age"
                                              maxLength={2}
                                              value={values.fam_age}
                                              onChange={handleChange("fam_age")}
                                              onBlur={() =>
                                                setFieldTouched("fam_age")
                                              }
                                              onChangeCapture={(e) =>
                                                setfam_age(e.target.value)
                                              }
                                            />
                                            {errors.fam_age &&
                                            touched.fam_age ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.fam_age}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={12}>
                                            <label className="tabsLabel">
                                              Residing In
                                            </label>
                                            <div className="myBtMain residingRadioOuter">
                                              <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                              >
                                                {familyMemAptList.length > 0 ? (
                                                  <>
                                                    {familyMemAptList.map(
                                                      (option, index) => (
                                                        <>
                                                          {option.occupancy_type ==
                                                          "Owner Occupied" ? (
                                                            <FormControlLabel
                                                              value={
                                                                option.uniq_apt_name
                                                              }
                                                              control={
                                                                <Radio />
                                                              }
                                                              label={
                                                                option.uniq_apt_name
                                                              }
                                                              onChange={(e) =>
                                                                handleSelectRadio(
                                                                  e,
                                                                  option.apartment_id
                                                                )
                                                              }
                                                              checked={
                                                                option.uniq_apt_name ==
                                                                fam_apartment_no
                                                              }
                                                            />
                                                          ) : (
                                                            <> </>
                                                          )}
                                                        </>
                                                      )
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {localStorage.getItem(
                                                      "buildingCnt"
                                                    ) > 0 ? (
                                                      <p className="wingErrorTx">
                                                        No owner occupied
                                                        apartment allocated
                                                        Please allocate
                                                        apartments.
                                                      </p>
                                                    ) : (
                                                      <p className="wingErrorTx">
                                                        No owner occupied
                                                        bunglow allocated Please
                                                        allocate bungalow.
                                                      </p>
                                                    )}
                                                  </>
                                                )}
                                              </RadioGroup>
                                              <p className="errorField">
                                                {selectApmtErrMsg}
                                              </p>
                                            </div>
                                          </Grid>

                                          <Grid item xs={12} md={12}>
                                            <Grid container spacing={3}>
                                              <Grid item xs={12} md={6}>
                                                {edfamilyflg ? (
                                                  <Button
                                                    className="addBt cancelBtForAll forFullWidthCancelBt"
                                                    onClick={handleCancelFamMem}
                                                  >
                                                    Cancel
                                                  </Button>
                                                ) : (
                                                  <></>
                                                )}
                                              </Grid>

                                              {famlisting.length <
                                                family_mem_cnt &&
                                              edfamilyflg == false ? (
                                                <Grid item xs={12} md={6}>
                                                  <Button
                                                    className="addApBt"
                                                    type="submit"
                                                  >
                                                    <div>Add Family Member</div>
                                                  </Button>
                                                </Grid>
                                              ) : (
                                                <>
                                                  {famlisting.length <=
                                                    family_mem_cnt &&
                                                  edfamilyflg ? (
                                                    <Grid item xs={12} md={6}>
                                                      <Button
                                                        className="addApBt"
                                                        type="submit"
                                                      >
                                                        <div>
                                                          {" "}
                                                          Update Family Member
                                                        </div>
                                                      </Button>
                                                    </Grid>
                                                  ) : (
                                                    <>
                                                      {family_mem_cnt == 0 ? (
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          md={12}
                                                        >
                                                          <p className="wingErrorTx">
                                                            Family Member count
                                                            is 0. If you want to
                                                            add family members
                                                            please update family
                                                            member count.
                                                          </p>
                                                        </Grid>
                                                      ) : (
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          md={12}
                                                        >
                                                          <p className="wingErrorTx">
                                                            All Family Members
                                                            already added. If
                                                            you want to add more
                                                            family members
                                                            please update family
                                                            member count.
                                                          </p>
                                                        </Grid>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}

                                              {/* <Grid item xs={12} md={6}>
                                      <Button className="addAprtmentBt">
                                        <AddIcon /> Add New Member
                                      </Button>
                                    </Grid> */}
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </div>
                                  </Form>
                                )}
                              </Formik>
                            </Grid>
                          </Grid>
                        </div>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      expanded={expanded === "panel3"}
                      onChange={handleChange2("panel3")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                      >
                        {edvehiflg ? (
                          <Typography>Update Vehicles</Typography>
                        ) : (
                          <Typography>Add Vehicles</Typography>
                        )}
                      </AccordionSummary>
                      <AccordionDetails>
                        <div
                          className="acordingCont"
                          style={{ margin: "10px 0 20px" }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <div className="tenentLeftContentMain">
                                {vehilisting.length > 0 ? (
                                  <ul>
                                    {vehilisting.map((option) => (
                                      <li
                                        className={
                                          option.vehicle_id == vehicleeditid
                                            ? "addedApartCont selectedTailSt"
                                            : "addedApartCont"
                                        }
                                      >
                                        <div>
                                          <CreateIcon
                                            className="delIc creatIcoForAdEdi"
                                            onClick={() =>
                                              editvehicle(option.vehicle_id)
                                            }
                                          />
                                          <DeleteIcon
                                            className="delIc"
                                            onClick={() =>
                                              deletevehicle(option.vehicle_id)
                                            }
                                          />
                                        </div>
                                        <h1 className="vehicleNameSt">
                                          {option.vehicle_type}
                                        </h1>
                                        <h4>
                                          {option.vehicle_owner_name} &nbsp;
                                          <em className="vehicleNoTx">
                                            {option.vehicle_no}
                                          </em>
                                        </h4>
                                        {/* <span>Reg No. {option.reg_no}</span> */}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <div className="recordNotFound">
                                    <img src={reecordNotFound} />
                                  </div>
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                              <Formik
                                enableReinitialize
                                initialValues={formikInitials_vehicle}
                                validationSchema={Validation_Schema_vehicle}
                                onSubmit={addvehicle}
                              >
                                {({
                                  values,
                                  handleChange,
                                  errors,
                                  setFieldTouched,
                                  touched,
                                  isValid,
                                  handleSubmit,
                                }) => (
                                  <Form>
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} md={6}>
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} md={12}>
                                            <label className="tabsLabel">
                                              Vehicle Type{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <select
                                              id="residentTypeList"
                                              className="inputSt"
                                              value={vehicleType}
                                              onChange={handlechangeVehicleType}
                                            >
                                              <option value="">
                                                Vehicle Type
                                              </option>
                                              <option value="Two Wheeler">
                                                Two Wheeler
                                              </option>
                                              <option value="Four Wheeler">
                                                Four Wheeler
                                              </option>
                                            </select>
                                            {errors.vehicleType &&
                                            touched.vehicleType ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.vehicleType}
                                              </div>
                                            ) : (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {vehicleTypeErrMsg}
                                              </div>
                                            )}
                                          </Grid>
                                          <Grid item xs={12} md={12}>
                                            <label className="tabsLabel">
                                              Owner Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Owner Name"
                                              value={values.ownername}
                                              onChange={handleChange(
                                                "ownername"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("ownername")
                                              }
                                              onChangeCapture={(e) =>
                                                setownername(e.target.value)
                                              }
                                            />
                                            {errors.ownername &&
                                            touched.ownername ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.ownername}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          {/* <label className="tabsLabel">
                                        Registration Number
                                      </label>
                                      <input
                                        className="inputSt inputStForAdVehicle"
                                        placeholder="Registration Number"
                                        value={values.registrationno}
                                        onChange={handleChange(
                                          "registrationno"
                                        )}
                                        onBlur={() =>
                                          setFieldTouched("registrationno")
                                        }
                                        onChangeCapture={(e) =>
                                          setregistrationno(e.target.value)
                                        }
                                      /> */}
                                          {/* {errors.registrationno &&
                                      touched.registrationno ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.registrationno}
                                        </div>
                                      ) : null} */}
                                          <Grid item xs={12} md={12}>
                                            <label className="tabsLabel">
                                              Vehicle Number{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Vehicle Number"
                                              value={values.vehicleno}
                                              onChange={handleChange(
                                                "vehicleno"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("vehicleno")
                                              }
                                              onChangeCapture={(e) =>
                                                setvehicleno(e.target.value)
                                              }
                                            />
                                            {errors.vehicleno &&
                                            touched.vehicleno ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.vehicleno}
                                              </div>
                                            ) : null}
                                          </Grid>
                                        </Grid>
                                      </Grid>

                                      <Grid item xs={12} md={6}>
                                        <div className="tabViewOfProviderRight">
                                          <h4 className="doquProviderHed">
                                            Documents
                                          </h4>
                                          <div className="societyDoc">
                                            <h4 className="documeUpload documeUploadIcon">
                                              Upload Documents
                                              <Button className="forUploadOnly">
                                                <FileUploadIcon />
                                                <input
                                                  type="file"
                                                  id="vehicleDocumentsList"
                                                  value={
                                                    values.vehicleDocumentsList
                                                  }
                                                  onChange={(event) =>
                                                    uploadDocuments(
                                                      event,
                                                      "vehicle"
                                                    )
                                                  }
                                                />
                                              </Button>
                                            </h4>
                                          </div>
                                          {vehDocErrorMsg ? (
                                            <div className="errorField errorFieldFForLogin forInvalidFile">
                                              {vehDocErrorMsg}
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {vehicleDocumentsList ? (
                                            <>
                                              <div className="docScrollBar">
                                                {vehicleDocumentsList.map(
                                                  (option, index) => (
                                                    <div className="doqumentDiv1">
                                                      <Zoom>
                                                        <div className="doquView">
                                                          {option
                                                            .split(".")
                                                            .pop() == "txt" ? (
                                                            <img
                                                              src={txtImage}
                                                            />
                                                          ) : option
                                                              .split(".")
                                                              .pop() ==
                                                            "pdf" ? (
                                                            <img
                                                              src={pdfImage}
                                                            />
                                                          ) : option
                                                              .split(".")
                                                              .pop() ==
                                                              "docx" ||
                                                            option
                                                              .split(".")
                                                              .pop() ==
                                                              "doc" ? (
                                                            <img
                                                              src={wordImage}
                                                            />
                                                          ) : option
                                                              .split(".")
                                                              .pop() == "xls" ||
                                                            option
                                                              .split(".")
                                                              .pop() ==
                                                              "xlsx" ? (
                                                            <img
                                                              src={excelImage}
                                                            />
                                                          ) : (
                                                            <img src={option} />
                                                          )}
                                                        </div>
                                                      </Zoom>
                                                      <span>
                                                        {option
                                                          .split("/")
                                                          .pop()
                                                          .replace("%20", " ")}
                                                        <DoneIcon />
                                                      </span>
                                                      {/* onclick={option=>deleteDocument(option,'resident')} */}
                                                      <Button
                                                        className="documRemove"
                                                        onClick={() =>
                                                          deleteDocument(
                                                            "vehicle",
                                                            index
                                                          )
                                                        }
                                                      >
                                                        <DeleteForeverIcon />
                                                      </Button>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </>
                                          ) : (
                                            <span>
                                              No Documents Uploaded yet
                                            </span>
                                          )}
                                        </div>
                                      </Grid>

                                      <Grid item xs={12} md={12}>
                                        <Grid container spacing={3}>
                                          <Grid item xs={12} md={6}>
                                            {edvehiflg ? (
                                              <Button
                                                className="addBt cancelBtForAll forFullWidthCancelBt"
                                                onClick={handleCancelVehicle}
                                              >
                                                Cancel
                                              </Button>
                                            ) : (
                                              <></>
                                            )}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <Button
                                              className="addApBt"
                                              type="submit"
                                            >
                                              {edvehiflg == true ? (
                                                <div> Edit Vehicle</div>
                                              ) : (
                                                <div>Add Vehicle</div>
                                              )}
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Form>
                                )}
                              </Formik>
                            </Grid>
                          </Grid>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </TabPanel>

          {/* Tenent Section */}
          <TabPanel
            value={value}
            index={1}
            className="tabPanelTopSpace tabPanelTopSpace2"
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                {/* <>Hi {tenentOccupiedAptmtCnt}  {buildListByResident}</> */}
                {tenentOccupiedAptmtCnt == 0 && tenentslist.length == 0 ? (
                  <span className="noTenentTx">
                    <b>No Apartment Allocated for Tenant </b>
                  </span>
                ) : (
                  <div className="tenentTabMain">
                    {tenentslist.map((option) => (
                      <div className="tenentTabInOut">
                        {/* <h5 className="tenetTbHeading">Tenent 1</h5> */}
                        <div
                          className={
                            option.resident_id == tenentEditId
                              ? "tenentTabInDiv tenentTabInDivActiveSt"
                              : "tenentTabInDiv"
                          }
                        >
                          <div className="manageIcons">
                            <CreateIcon
                              className="delIc creatIcoForAdEdi"
                              onClick={() => edittents(option.resident_id)}
                            />
                            {/* <DeleteIcon
                              className="delIc forTenantIcoAction"
                              onClick={() => deletetents(option.resident_id)}
                            /> */}
                            <Tooltip
                              title="Release Tenant"
                              placement="top"
                              arrow
                            >
                              <AddHomeIcon
                                className="rellocationIco delIc"
                                onClick={() => deletetents(option.resident_id)}
                              />
                            </Tooltip>
                          </div>
                          <div className="tenentTabInPro">
                            <Zoom>
                              {option.user_obj.profile_pic ? (
                                <img src={option.user_obj.profile_pic} />
                              ) : (
                                <img src={defaultProfilePic} />
                              )}
                            </Zoom>
                          </div>
                          <h4>
                            {option.user_obj.first_name}{" "}
                            {option.user_obj.last_name}{" "}
                          </h4>
                          <h5 className="tenetTbHeadingNew">
                            {option.uniq_apt_name}
                          </h5>
                          <span>{option.user_obj.age} Years</span>
                        </div>
                      </div>
                    ))}
                    <Button className="addNewenentBtn">
                      <AddIcon /> Add New Tenent
                    </Button>
                  </div>
                )}
              </Grid>
            </Grid>

            {buildListByResident.length > 0 || edtentsflg == true ? (
              <Grid item xs={12} md={12}>
                {tenentOccupiedAptmtCnt != 0 || tenentslist.length > 0 ? (
                  <>
                    <div className="acordingViewMain">
                      <Accordion
                        expanded={expanded === "panel02"}
                        onChange={handleChange2("panel02")}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                        >
                          <Typography>Add Tenant Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="acordingCont">
                            <Formik
                              enableReinitialize
                              initialValues={formikInitials_tents}
                              validationSchema={Validation_Schema_Tenents}
                              onSubmit={addTenent}
                            >
                              {({
                                values,
                                handleChange,
                                errors,
                                setFieldTouched,
                                touched,
                                isValid,
                                handleSubmit,
                                registerField,
                              }) => (
                                <Form>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                      <div className="tabLeftDiv">
                                        <div className="uploadImDiv">
                                          <div className="uploadIm">
                                            {tenentProfilePic ? (
                                              <img src={tenentProfilePic} />
                                            ) : (
                                              <img src={defaultProfilePic} />
                                            )}
                                          </div>
                                          <div className="uploadInpu">
                                            <FileUploadIcon />
                                            <span>Upload Profile Photo</span>
                                            <em className="uploadPhotoErrorMsg">
                                              {tenenProfileErrMsg}
                                            </em>
                                            <input
                                              type="file"
                                              id="tenentProfilePic"
                                              value={values.tenentProfilePic}
                                              onChange={(event) =>
                                                uploadProfilePic(
                                                  event,
                                                  "tenent"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <Grid container spacing={3}>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              First Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="First Name"
                                              value={values.firstname_tents}
                                              onChange={handleChange(
                                                "firstname_tents"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched(
                                                  "firstname_tents"
                                                )
                                              }
                                              onChangeCapture={(e) =>
                                                setfirstname_tents(
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {errors.firstname_tents &&
                                            touched.firstname_tents ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.firstname_tents}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Last Name{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Last Name"
                                              value={values.lastname_tents}
                                              onChange={handleChange(
                                                "lastname_tents"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched(
                                                  "lastname_tents"
                                                )
                                              }
                                              onChangeCapture={(e) =>
                                                setlastname_tents(
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {errors.lastname_tents &&
                                            touched.lastname_tents ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.lastname_tents}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Phone Number{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Phone Number"
                                              maxLength={10}
                                              id="contact_tents"
                                              value={values.contact_tents}
                                              onChange={handleChange(
                                                "contact_tents"
                                              )}
                                              onBlur={(e) =>
                                                setFieldTouched("contact_tents")
                                              }
                                              // onBlur={(e) =>
                                              //   getUserByContactNo(e.target.value, "Tenent")
                                              // }
                                              onChangeCapture={(e) =>
                                                setcontact_tents(e.target.value)
                                              }
                                            />
                                            {errors.contact_tents &&
                                            touched.contact_tents ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.contact_tents}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Email Id{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>

                                            <input
                                              className="inputSt"
                                              placeholder="Email Id"
                                              id="email_tents"
                                              value={values.email_tents}
                                              onChange={handleChange(
                                                "email_tents"
                                              )}
                                              // onBlur={(e) =>
                                              //   getUserByEmailId(e.target.value, "Tenent")
                                              // }
                                              onBlur={(e) =>
                                                setFieldTouched("email_tents")
                                              }
                                              onChangeCapture={(e) =>
                                                setemail_tents(e.target.value)
                                              }
                                            />
                                            {errors.email_tents &&
                                            touched.email_tents ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.email_tents}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Age{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Age"
                                              maxLength={2}
                                              value={values.tenent_age}
                                              onChange={handleChange(
                                                "tenent_age"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("tenent_age")
                                              }
                                              onChangeCapture={(e) =>
                                                setTenent_age(e.target.value)
                                              }
                                            />
                                            {errors.tenent_age &&
                                            touched.tenent_age ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.tenent_age}
                                              </div>
                                            ) : null}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <label className="tabsLabel">
                                              Family Member Count{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>
                                            <input
                                              className="inputSt"
                                              placeholder="Family Member Count"
                                              maxLength={2}
                                              value={values.family_member}
                                              onChange={handleChange(
                                                "family_member"
                                              )}
                                              onBlur={() =>
                                                setFieldTouched("family_member")
                                              }
                                              onChangeCapture={(e) =>
                                                setfamily_member(e.target.value)
                                              }
                                            />
                                            {errors.family_member &&
                                            touched.family_member ? (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {errors.family_member}
                                              </div>
                                            ) : (
                                              <div
                                                style={{ color: "red" }}
                                                className="errorField"
                                              >
                                                {tenentFamMemErrMsg}
                                              </div>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                      <div className="tabViewOfProviderRight">
                                        <h4 className="doquProviderHed">
                                          Documents
                                        </h4>
                                        <div className="societyDoc">
                                          <h4 className="documeUpload documeUploadIcon">
                                            Upload Documents
                                            <Button className="forUploadOnly">
                                              <FileUploadIcon />
                                              <input
                                                type="file"
                                                id="tenentDocumentsList"
                                                value={
                                                  values.tenentDocumentsList
                                                }
                                                onChange={(event) =>
                                                  uploadDocuments(
                                                    event,
                                                    "tenent"
                                                  )
                                                }
                                                style={{
                                                  opacity: 0,
                                                  position: "absolute",
                                                  left: 0,
                                                }}
                                              />
                                            </Button>
                                          </h4>
                                        </div>
                                        {tenentDocErrorMsg ? (
                                          <div className="errorField errorFieldFForLogin forInvalidFile">
                                            {tenentDocErrorMsg}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        {tenentDocumentsList ? (
                                          <>
                                            <div className="docScrollBar">
                                              {tenentDocumentsList.map(
                                                (option, index) => (
                                                  <div className="doqumentDiv1 kkk">
                                                    <Zoom>
                                                      <div className="doquView">
                                                        {option
                                                          .split(".")
                                                          .pop() == "txt" ? (
                                                          <img src={txtImage} />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "pdf" ? (
                                                          <img src={pdfImage} />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "docx" ||
                                                          option
                                                            .split(".")
                                                            .pop() == "doc" ? (
                                                          <img
                                                            src={wordImage}
                                                          />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "xls" ||
                                                          option
                                                            .split(".")
                                                            .pop() == "xlsx" ? (
                                                          <img
                                                            src={excelImage}
                                                          />
                                                        ) : (
                                                          <img src={option} />
                                                        )}
                                                      </div>
                                                    </Zoom>
                                                    <span>
                                                      {option
                                                        .split("/")
                                                        .pop()
                                                        .replace("%20", " ")}
                                                      <DoneIcon />
                                                    </span>

                                                    <Button
                                                      className="documRemove"
                                                      onClick={() =>
                                                        deleteDocument(
                                                          "tenent",
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <DeleteForeverIcon />
                                                    </Button>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          <span>No Documents Uploaded yet</span>
                                        )}
                                      </div>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                      <Grid container spacing={3}>
                                        {localStorage.getItem("buildingCnt") ==
                                        0 ? (
                                          <>
                                            <Grid item xs={12} md={12}>
                                              {edtentsflg == true ? (
                                                <h4 className="addApHeading">
                                                  Assigned Bungalow
                                                </h4>
                                              ) : (
                                                <h4 className="addApHeading">
                                                  Assign Bungalow
                                                </h4>
                                              )}
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                              <label className="tabsLabel">
                                                Select Bungalow
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                id="tenentAptList"
                                                className="inputSt"
                                                value={tenentApartment}
                                                onChange={
                                                  handlechangTenentApartment
                                                }
                                              >
                                                <option value="" disabled>
                                                  Select Bungalow
                                                </option>
                                                {aptmtListByResident.map(
                                                  (option) => (
                                                    <option
                                                      key={option.apartment_id}
                                                      value={
                                                        option.apartment_id
                                                      }
                                                      data-isd={
                                                        option.apartment_no
                                                      }
                                                    >
                                                      {option.apartment_no}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </Grid>
                                          </>
                                        ) : (
                                          <>
                                            <Grid item xs={12} md={12}>
                                              {edtentsflg == true ? (
                                                <h4 className="addApHeading">
                                                  Assigned Apartment
                                                </h4>
                                              ) : (
                                                <h4 className="addApHeading">
                                                  Assign Apartment
                                                </h4>
                                              )}
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                              <label className="tabsLabel">
                                                Select Building{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                // {...registerField("tenentBuilding")}
                                                id="tenentBuildingList"
                                                className="inputSt"
                                                value={tenentBuilding}
                                                onChange={
                                                  GetTenentOccupiedWingList
                                                }
                                              >
                                                <option value="" disabled>
                                                  Select Building
                                                </option>
                                                {buildListByResident.map(
                                                  (option) => (
                                                    <option
                                                      key={option.building_id}
                                                      value={option.building_id}
                                                      data-isd={
                                                        option.building_name
                                                      }
                                                    >
                                                      {option.building_name}
                                                    </option>
                                                  )
                                                )}
                                              </select>

                                              {errors.tenentBuilding &&
                                              touched.tenentBuilding ? (
                                                <div
                                                  style={{ color: "red" }}
                                                  className="errorField"
                                                >
                                                  {errors.tenentBuilding}
                                                </div>
                                              ) : null}
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                              <label className="tabsLabel">
                                                Select Wing{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                id="tenentWingList"
                                                className="inputSt"
                                                value={tenentWing}
                                                onChange={
                                                  GetTenentOccupiedApartmentList
                                                }
                                              >
                                                <option value="">
                                                  Select Wing
                                                </option>
                                                {wingListByResident.map(
                                                  (option) => (
                                                    <option
                                                      key={option.wing_id}
                                                      value={option.wing_id}
                                                      data-isd={
                                                        option.wing_name
                                                      }
                                                    >
                                                      {option.wing_name}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                              <label className="tabsLabel">
                                                Select Apartment{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                id="tenentAptList"
                                                className="inputSt"
                                                value={tenentApartment}
                                                onChange={
                                                  handlechangTenentApartment
                                                }
                                              >
                                                <option value="" disabled>
                                                  Select Apartment
                                                </option>
                                                {aptmtListByResident.map(
                                                  (option) => (
                                                    <option
                                                      key={option.apartment_id}
                                                      value={
                                                        option.apartment_id
                                                      }
                                                      data-isd={
                                                        option.apartment_no
                                                      }
                                                    >
                                                      {option.apartment_no}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </Grid>

                                            {/* <Grid item xs={12} md={4}>
                                                  <label className="tabsLabel">
                                                    Owner current Stay
                                                  </label>
                                                  <div className="myBtMain mainRadioSt">
                                                    <RadioGroup
                                                      aria-labelledby="demo-radio-buttons-group-label"
                                                      defaultValue="female"
                                                      name="radio-buttons-group"
                                                    >
                                                      <FormControlLabel
                                                        value="true"
                                                        control={<Radio />}
                                                        label="Yes"
                                                        checked={
                                                          isCurrentStay === true
                                                        }
                                                        onChange={(e) =>
                                                          setIsCurrentStay(e.target.value)
                                                        }
                                                      />
                                                      <FormControlLabel
                                                        value="false"
                                                        control={<Radio />}
                                                        label="No"
                                                        checked={
                                                          isCurrentStay === true
                                                        }
                                                        onChange={(e) =>
                                                          setIsCurrentStay(e.target.value)
                                                        }
                                                      />
                                                    </RadioGroup>
                                                  </div>
                                                </Grid> */}
                                          </>
                                        )}

                                        <Grid
                                          item
                                          xs={12}
                                          md={12}
                                          style={{ textAlign: "center" }}
                                        >
                                          {edtentsflg ? (
                                            <Button
                                              className="addBt cancelBtForAll"
                                              onClick={cancelTenent}
                                            >
                                              Cancel
                                            </Button>
                                          ) : (
                                            <></>
                                          )}

                                          <Button
                                            className="addBt"
                                            type="submit"
                                            // onClick={() => addTenent()}
                                          >
                                            {edtentsflg == true ? (
                                              <div> Edit Tenant</div>
                                            ) : (
                                              <div> Add Tenant</div>
                                            )}
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </AccordionDetails>
                      </Accordion>

                      {hidetenentFamVehDiv ? (
                        <>
                          <Accordion
                            expanded={expanded === "panel03"}
                            onChange={handleChange2("panel03")}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2bh-content"
                              id="panel2bh-header"
                            >
                              {edTenentFamilyFlag ? (
                                <Typography>Update Family Members</Typography>
                              ) : (
                                <Typography>Add Family Members</Typography>
                              )}
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="acordingCont">
                                <Grid
                                  container
                                  spacing={3}
                                  style={{ marginTop: "10px" }}
                                >
                                  <Grid item xs={12} md={4}>
                                    {tenentFamMemList.length > 0 ? (
                                      <div className="tenentLeftContentMain">
                                        <ul>
                                          {tenentFamMemList.map((option) => (
                                            <li
                                              className={
                                                option.member_id ==
                                                tenentFamilyEditId
                                                  ? "selectedTailSt"
                                                  : ""
                                              }
                                            >
                                              <div>
                                                <CreateIcon
                                                  className="delIc creatIcoForAdEdi"
                                                  onClick={() =>
                                                    editTenentFamilyMember(
                                                      option.member_id
                                                    )
                                                  }
                                                />
                                                <DeleteIcon
                                                  className="delIc"
                                                  onClick={() =>
                                                    deletefamilymember(
                                                      option.member_id
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div className="tenantDProfile">
                                                <Zoom>
                                                  {option.user_obj
                                                    .profile_pic ? (
                                                    <img
                                                      src={
                                                        option.user_obj
                                                          .profile_pic
                                                      }
                                                    />
                                                  ) : (
                                                    <img
                                                      src={defaultProfilePic}
                                                    />
                                                  )}
                                                </Zoom>
                                              </div>
                                              <h4>
                                                {option.user_obj.first_name}{" "}
                                                {option.user_obj.last_name}{" "}
                                              </h4>
                                              <div className="relationAndAge">
                                                <span>{option.relation}</span>
                                                <b className="ageSt">
                                                  {option.user_obj.age} Years
                                                </b>
                                              </div>
                                              <div className="uploadDetailsOut">
                                                <span className="mobNum">
                                                  <CallIcon className="forEmailAndPhone" />
                                                  {option.user_obj.contact_no}
                                                </span>
                                                <span>
                                                  <MarkunreadIcon className="forEmailAndPhone" />
                                                  {option.user_obj.email_id}
                                                </span>
                                              </div>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    ) : (
                                      <div className="recordNotFound">
                                        <img src={reecordNotFound} />
                                      </div>
                                    )}
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <Formik
                                      enableReinitialize
                                      initialValues={
                                        formikInitials_Tenentfamily
                                      }
                                      validationSchema={
                                        Validation_Schema_Tenentfamily
                                      }
                                      onSubmit={addTenentFamilymem}
                                    >
                                      {({
                                        values,
                                        handleChange,
                                        errors,
                                        setFieldTouched,
                                        touched,
                                        isValid,
                                        handleSubmit,
                                      }) => (
                                        <Form>
                                          <div className="newAddResiMain">
                                            <div className="tabLeftDiv">
                                              <div className="uploadImDiv">
                                                <div className="uploadIm">
                                                  {tenentFamMemberProfPic ? (
                                                    <img
                                                      src={
                                                        tenentFamMemberProfPic
                                                      }
                                                    />
                                                  ) : (
                                                    <img
                                                      src={defaultProfilePic}
                                                    />
                                                  )}
                                                </div>
                                                <div className="uploadInpu">
                                                  <FileUploadIcon />
                                                  <span>
                                                    Upload Profile Photo
                                                  </span>
                                                  <em className="uploadPhotoErrorMsg">
                                                    {tenenFamMemProfileErrMsg}
                                                  </em>
                                                  <input
                                                    type="file"
                                                    id="tenentFamMemberProfPic"
                                                    value={
                                                      values.tenentFamMemberProfPic
                                                    }
                                                    onChange={(event) =>
                                                      uploadProfilePic(
                                                        event,
                                                        "tenentFamilyMember"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>

                                              <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    First Name
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>

                                                  <input
                                                    className="inputSt"
                                                    placeholder="First Name"
                                                    value={
                                                      values.fName_TenentFam
                                                    }
                                                    onChange={handleChange(
                                                      "fName_TenentFam"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "fName_TenentFam"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setFName_TenentFam(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.fName_TenentFam &&
                                                  touched.fName_TenentFam ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.fName_TenentFam}
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Last Name
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    className="inputSt"
                                                    placeholder="Last Name"
                                                    value={
                                                      values.lName_TenentFam
                                                    }
                                                    onChange={handleChange(
                                                      "lName_TenentFam"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "lName_TenentFam"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setlName_TenentFam(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.lName_TenentFam &&
                                                  touched.lName_TenentFam ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.lName_TenentFam}
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Phone Number
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    className="inputSt"
                                                    placeholder="Phone Number"
                                                    maxLength={10}
                                                    value={
                                                      values.contact_TenentFam
                                                    }
                                                    onChange={handleChange(
                                                      "contact_TenentFam"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "contact_TenentFam"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setContact_TenentFam(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.contact_TenentFam &&
                                                  touched.contact_TenentFam ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.contact_TenentFam}
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Relation
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select
                                                    className="inputSt"
                                                    value={relation_TenentFam}
                                                    onChange={(e) =>
                                                      setRelation_TenentFam(
                                                        e.target.value
                                                      )
                                                    }
                                                  >
                                                    <option>Select</option>
                                                    <option value="Father">
                                                      Father
                                                    </option>
                                                    <option value="Mother">
                                                      Mother
                                                    </option>
                                                    <option value="Son">
                                                      Son
                                                    </option>
                                                    <option value="Daughter">
                                                      Daughter
                                                    </option>
                                                    <option value="Husband">
                                                      Husband
                                                    </option>
                                                    <option value="Wife">
                                                      Wife
                                                    </option>
                                                    <option value="Brother">
                                                      Brother
                                                    </option>
                                                    <option value="Sister">
                                                      Sister
                                                    </option>
                                                    <option value="Grandfather">
                                                      Grandfather
                                                    </option>
                                                    <option value="Grandmother">
                                                      Grandmother
                                                    </option>
                                                    <option value="Grandson">
                                                      Grandson
                                                    </option>
                                                    <option value="Uncle">
                                                      Uncle
                                                    </option>
                                                    <option value="Aunt">
                                                      Aunt
                                                    </option>
                                                    <option value="Nephew">
                                                      Nephew
                                                    </option>
                                                    <option value="Niece">
                                                      Niece
                                                    </option>
                                                    <option value="Cousin">
                                                      Cousin
                                                    </option>
                                                    {/* <option>Other</option> */}
                                                  </select>
                                                  {/* <input
                                          className="inputSt"
                                          placeholder="Relation"
                                          value={values.relation_TenentFam}
                                          onChange={handleChange(
                                            "relation_TenentFam"
                                          )}
                                          onBlur={() =>
                                            setFieldTouched(
                                              "relation_TenentFam"
                                            )
                                          }
                                          onChangeCapture={(e) =>
                                            setRelation_TenentFam(
                                              e.target.value
                                            )
                                          }
                                        /> */}
                                                  {errors.relation_TenentFam &&
                                                  touched.relation_TenentFam ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {
                                                        errors.relation_TenentFam
                                                      }
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Email Id
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    className="inputSt"
                                                    placeholder="Email Id"
                                                    value={
                                                      values.email_TenentFam
                                                    }
                                                    onChange={handleChange(
                                                      "email_TenentFam"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "email_TenentFam"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setEmail_TenentFam(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.email_TenentFam &&
                                                  touched.email_TenentFam ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.email_TenentFam}
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <label className="tabsLabel">
                                                    Age
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    className="inputSt"
                                                    placeholder="Age"
                                                    maxLength={2}
                                                    value={values.age_TenentFam}
                                                    onChange={handleChange(
                                                      "age_TenentFam"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "age_TenentFam"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setAge_TenentFam(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.age_TenentFam &&
                                                  touched.age_TenentFam ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.age_TenentFam}
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                <Grid item xs={12} md={12}>
                                                  <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                      {edTenentFamilyFlag ? (
                                                        <Button
                                                          className="addBt cancelBtForAll forFullWidthCancelBt"
                                                          onClick={
                                                            cancelTenentFamMem
                                                          }
                                                        >
                                                          Cancel
                                                        </Button>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </Grid>

                                                    {tenentFamMemList.length <
                                                      family_member &&
                                                    edTenentFamilyFlag ==
                                                      false ? (
                                                      <Grid item xs={12} md={6}>
                                                        <Button
                                                          className="addApBt"
                                                          type="submit"
                                                        >
                                                          <div>
                                                            {" "}
                                                            Add Family Member
                                                          </div>
                                                        </Button>
                                                      </Grid>
                                                    ) : (
                                                      <>
                                                        {tenentFamMemList.length <=
                                                          family_member &&
                                                        edTenentFamilyFlag ? (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                          >
                                                            <Button
                                                              className="addApBt"
                                                              type="submit"
                                                            >
                                                              <div>
                                                                {" "}
                                                                Update Family
                                                                Member
                                                              </div>
                                                            </Button>
                                                          </Grid>
                                                        ) : (
                                                          <>
                                                            {family_member ==
                                                            0 ? (
                                                              <Grid
                                                                item
                                                                xs={12}
                                                                md={12}
                                                              >
                                                                <p className="wingErrorTx">
                                                                  Family Member
                                                                  count is 0. If
                                                                  you want to
                                                                  add family
                                                                  members please
                                                                  update family
                                                                  member count.
                                                                </p>
                                                              </Grid>
                                                            ) : (
                                                              <Grid
                                                                item
                                                                xs={12}
                                                                md={12}
                                                              >
                                                                <p className="wingErrorTx">
                                                                  All Family
                                                                  Members
                                                                  already added.
                                                                  If you want to
                                                                  add more
                                                                  family members
                                                                  please update
                                                                  family member
                                                                  count.
                                                                </p>
                                                              </Grid>
                                                            )}
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </div>
                                        </Form>
                                      )}
                                    </Formik>
                                  </Grid>
                                </Grid>
                              </div>
                            </AccordionDetails>
                          </Accordion>

                          <Accordion
                            expanded={expanded === "panel04"}
                            onChange={handleChange2("panel04")}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2bh-content"
                              id="panel2bh-header"
                            >
                              {tenentVehicleEditFlg ? (
                                <Typography>Update Vehicles</Typography>
                              ) : (
                                <Typography>Add Vehicles</Typography>
                              )}
                            </AccordionSummary>
                            <AccordionDetails>
                              <div
                                className="acordingCont"
                                style={{ margin: "10px 0 20px" }}
                              >
                                <Grid container spacing={3}>
                                  <Grid item xs={12} md={4}>
                                    {tenentVehicleList.length > 0 ? (
                                      <div className="tenentLeftContentMain">
                                        <ul>
                                          {tenentVehicleList.map((option) => (
                                            <li
                                              className={
                                                option.vehicle_id ==
                                                tenentVehicleEditId
                                                  ? "addedApartCont selectedTailSt"
                                                  : "addedApartCont"
                                              }
                                            >
                                              <div>
                                                <CreateIcon
                                                  className="delIc creatIcoForAdEdi"
                                                  onClick={() =>
                                                    editTenentVehicle(
                                                      option.vehicle_id
                                                    )
                                                  }
                                                />
                                                <DeleteIcon
                                                  className="delIc"
                                                  onClick={() =>
                                                    deletevehicle(
                                                      option.vehicle_id
                                                    )
                                                  }
                                                />
                                              </div>
                                              <h1 className="vehicleNameSt">
                                                {option.vehicle_type}
                                              </h1>
                                              <h4>
                                                {option.vehicle_owner_name}{" "}
                                                &nbsp;
                                                <em className="vehicleNoTx">
                                                  {" "}
                                                  {option.vehicle_no}{" "}
                                                </em>
                                              </h4>
                                              {/* <span>Reg No. {option.reg_no}</span> */}
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    ) : (
                                      <div className="recordNotFound">
                                        <img src={reecordNotFound} />
                                      </div>
                                    )}
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <Formik
                                      enableReinitialize
                                      initialValues={
                                        formikInitials_TenentVehicle
                                      }
                                      validationSchema={
                                        Validation_Schema_TenentVehicle
                                      }
                                      onSubmit={addTenentVehicle}
                                    >
                                      {({
                                        values,
                                        handleChange,
                                        errors,
                                        setFieldTouched,
                                        touched,
                                        isValid,
                                        handleSubmit,
                                      }) => (
                                        <Form>
                                          <Grid container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                              <Grid container spacing={2}>
                                                <Grid item xs={12} md={12}>
                                                  <label className="tabsLabel">
                                                    Vehicle Type
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <select
                                                    id="residentTypeList"
                                                    className="inputSt"
                                                    value={tenentVehicleType}
                                                    onChange={
                                                      handlechangeTenentVehicleType
                                                    }
                                                  >
                                                    <option value="">
                                                      Vehicle Type
                                                    </option>
                                                    <option value="Two Wheeler">
                                                      Two Wheeler
                                                    </option>
                                                    <option value="Four Wheeler">
                                                      Four Wheeler
                                                    </option>
                                                  </select>
                                                  <div
                                                    style={{ color: "red" }}
                                                    className="errorField"
                                                  >
                                                    {tenantVehicleTypeErrMsg}
                                                  </div>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                  <label className="tabsLabel">
                                                    Owner Name
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    className="inputSt"
                                                    placeholder="Owner Name"
                                                    value={
                                                      values.tenentV_OwnerName
                                                    }
                                                    onChange={handleChange(
                                                      "tenentV_OwnerName"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "tenentV_OwnerName"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setTenentVOwnerName(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.tenentV_OwnerName &&
                                                  touched.tenentV_OwnerName ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.tenentV_OwnerName}
                                                    </div>
                                                  ) : null}
                                                </Grid>

                                                {/* <label className="tabsLabel">
                                      Registration Number
                                    </label>
                                    <input
                                      className="inputSt inputStForAdVehicle"
                                      placeholder="Registration Number"
                                      value={values.tenentV_RegNo}
                                      onChange={handleChange("tenentV_RegNo")}
                                      onBlur={() =>
                                        setFieldTouched("tenentV_RegNo")
                                      }
                                      onChangeCapture={(e) =>
                                        setTenentVRegNo(e.target.value)
                                      }
                                    />
                                    {errors.tenentV_RegNo &&
                                    touched.tenentV_RegNo ? (
                                      <div
                                        style={{ color: "red" }}
                                        className="errorField"
                                      >
                                        {errors.tenentV_RegNo}
                                      </div>
                                    ) : null} */}
                                                <Grid item xs={12} md={12}>
                                                  <label className="tabsLabel">
                                                    Vehicle Number
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    className="inputSt"
                                                    placeholder="Vehicle Number"
                                                    value={
                                                      values.tenentVehicleNo
                                                    }
                                                    onChange={handleChange(
                                                      "tenentVehicleNo"
                                                    )}
                                                    onBlur={() =>
                                                      setFieldTouched(
                                                        "tenentVehicleNo"
                                                      )
                                                    }
                                                    onChangeCapture={(e) =>
                                                      setTenentVehicleNo(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                  {errors.tenentVehicleNo &&
                                                  touched.tenentVehicleNo ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                      className="errorField"
                                                    >
                                                      {errors.tenentVehicleNo}
                                                    </div>
                                                  ) : null}
                                                </Grid>
                                              </Grid>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                              <div className="tabViewOfProviderRight">
                                                <h4 className="doquProviderHed">
                                                  Documents
                                                </h4>
                                                <div className="societyDoc">
                                                  <h4 className="documeUpload documeUploadIcon">
                                                    Upload Documents
                                                    <Button className="forUploadOnly">
                                                      <FileUploadIcon />
                                                      <input
                                                        type="file"
                                                        id="tenentVehicleDocList"
                                                        value={
                                                          values.tenentVehicleDocList
                                                        }
                                                        onChange={(event) =>
                                                          uploadDocuments(
                                                            event,
                                                            "tenentVehicle"
                                                          )
                                                        }
                                                        style={{
                                                          opacity: 0,
                                                          position: "absolute",
                                                          left: 0,
                                                        }}
                                                      />
                                                    </Button>
                                                  </h4>
                                                </div>
                                                {tenentVehDocErrorMsg ? (
                                                  <div className="errorField errorFieldFForLogin forInvalidFile">
                                                    {tenentVehDocErrorMsg}
                                                  </div>
                                                ) : (
                                                  <></>
                                                )}
                                                {tenentVehicleDocList ? (
                                                  <>
                                                    <div className="docScrollBar">
                                                      {tenentVehicleDocList.map(
                                                        (option, index) => (
                                                          <div className="doqumentDiv1">
                                                            <Zoom>
                                                              <div className="doquView">
                                                                {option
                                                                  .split(".")
                                                                  .pop() ==
                                                                "txt" ? (
                                                                  <img
                                                                    src={
                                                                      txtImage
                                                                    }
                                                                  />
                                                                ) : option
                                                                    .split(".")
                                                                    .pop() ==
                                                                  "pdf" ? (
                                                                  <img
                                                                    src={
                                                                      pdfImage
                                                                    }
                                                                  />
                                                                ) : option
                                                                    .split(".")
                                                                    .pop() ==
                                                                    "docx" ||
                                                                  option
                                                                    .split(".")
                                                                    .pop() ==
                                                                    "doc" ? (
                                                                  <img
                                                                    src={
                                                                      wordImage
                                                                    }
                                                                  />
                                                                ) : option
                                                                    .split(".")
                                                                    .pop() ==
                                                                    "xls" ||
                                                                  option
                                                                    .split(".")
                                                                    .pop() ==
                                                                    "xlsx" ? (
                                                                  <img
                                                                    src={
                                                                      excelImage
                                                                    }
                                                                  />
                                                                ) : (
                                                                  <img
                                                                    src={option}
                                                                  />
                                                                )}
                                                              </div>
                                                            </Zoom>

                                                            <span>
                                                              {option
                                                                .split("/")
                                                                .pop()
                                                                .replace(
                                                                  "%20",
                                                                  " "
                                                                )}
                                                              <DoneIcon />
                                                            </span>
                                                            {/* onclick={option=>deleteDocument(option,'resident')} */}
                                                            <Button
                                                              className="documRemove"
                                                              onClick={() =>
                                                                deleteDocument(
                                                                  "tenentVehicle",
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              <DeleteForeverIcon />
                                                            </Button>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  </>
                                                ) : (
                                                  <span>
                                                    No Documents Uploaded yet
                                                  </span>
                                                )}
                                              </div>
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                              <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                  {tenentVehicleEditFlg ? (
                                                    <Button
                                                      className="addBt cancelBtForAll forFullWidthCancelBt"
                                                      onClick={
                                                        cancelTenentVehicle
                                                      }
                                                    >
                                                      Cancel
                                                    </Button>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                  <Button
                                                    className="addApBt"
                                                    type="submit"
                                                  >
                                                    {tenentVehicleEditFlg ==
                                                    true ? (
                                                      <div> Edit Vehicle </div>
                                                    ) : (
                                                      <div> Add Vehicle</div>
                                                    )}
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Form>
                                      )}
                                    </Formik>
                                  </Grid>
                                </Grid>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            ) : (
              <>
                <>{buildListByResident}</>
                {buildListByResident.length == 0 && tenentslist.length > 0 ? (
                  <Grid item xs={12} md={12}>
                    <span className="noTenentTx">
                      <b>No More Apartment Allocated for Tenant </b>
                    </span>
                  </Grid>
                ) : (
                  <></>
                )}
              </>
            )}
          </TabPanel>
        </Box>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Success !</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="succesMain">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                    <h4>Success !</h4>
                    <p>
                      Resident added successfully in <br /> database
                    </p>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* Change Password */}
      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Change Password</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <label className="tabsLabel">Old Password</label>
                    <div className="passwordOut passwordOutChangePas">
                      <Input
                        className="modalInputStSelect"
                        type="password"
                        id="oldPassword"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                      <div className="passwordshowIcon">
                        <RemoveRedEyeIcon
                          onClick={() => showPassword("oldPassword")}
                        />
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <label className="tabsLabel">New Password</label>
                    <div className="passwordOut passwordOutChangePas">
                      <Input
                        className="modalInputStSelect"
                        type="password"
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => validatePassword(e.target.value)}
                      />
                      <div className="passwordshowIcon">
                        <RemoveRedEyeIcon
                          onClick={() => showPassword("newPassword")}
                        />
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <label className="tabsLabel">Confirm New Password</label>
                    <div className="passwordOut passwordOutChangePas">
                      <Input
                        className="modalInputStSelect"
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) =>
                          handleChangeConfirmPassword(e.target.value)
                        }
                      />
                      <div className="passwordshowIcon">
                        <RemoveRedEyeIcon
                          onClick={() => showPassword("confirmPassword")}
                        />
                      </div>
                    </div>
                    {successMsg == "Password Verified.." ? (
                      <span className="wrongPassError successMsg">
                        {successMsg}
                      </span>
                    ) : (
                      <span className="wrongPassError">{confirmErrorMsg}</span>
                    )}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button
                        className="modalMainBt"
                        onClick={() => changePassword()}
                      >
                        Submit
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>
                        Password Changed <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default ResidentDetailsTab;
